{
  "imageCropper": {
    "title": "Recadrer la photo de profil",
    "hint": "Glissez pour repositionner",
    "cancel": "Annuler",
    "confirm": "Confirmer"
  },
  "common": {
    "upload": "Importer",
    "search": "Rechercher",
    "searchInput": {
      "placeholder": "Rechercher une ressource"
    },
    "planzoneKnowledge": "Centre d'aide",
    "filterMenu": {
      "search": "Rechercher",
      "erase": "Effacer les filtres",
      "zones": {
        "title": "Toutes les zones"
      },
      "projects": {
        "title": "Projets"
      },
      "projectPortfolios": {
        "title": "Portefeuilles"
      },
      "projectsElementsTags": {
        "title": "Tags"
      },
      "projectsTags": {
        "title": "Tags projets"
      },
      "projectStatuses": {
        "title": "Statuts de projet"
      },
      "resourceTags": {
        "title": "Tags ressource"
      },
      "resources": {
        "title": "Utilisateurs",
        "everyone": "Tout le monde",
        "me": "moi"
      },
      "groups": {
        "title": "Groupes"
      },
      "roles": {
        "title": "Rôles"
      },
      "organizationalUnits": {
        "title": "Unités organisationnelles"
      }
    },
    "resourceAllocationForm": {
      "searchPlaceholder": "Rechercher",
      "allResources": "Tout le monde",
      "me": " (moi)",
      "resources": "Utilisateurs",
      "groups": "Groupes",
      "resourceTags": "Tags ressource"
    },
    "scenePlaceholder": {
      "title": "Cette page n'est pas disponible",
      "message": "Vous n'avez pas accès à ce lien ou ce lien n'est pas valide",
      "goBack": "Précédent"
    },
    "constraintsPopup": {
      "remainingConstrainedElementsTitle": "Est contraint par",
      "constrainedElementsTitle": "Contraint",
      "title": "En attente de validation des éléments suivants",
      "seeConstraint": "Voir plus"
    },
    "removedCommentAuthor": "Ressource supprimée",
    "secondaryCriteriaTemplatePlaceholder": {
      "title": "Vous n'avez pas encore configuré vos champs personnalisés",
      "message": "Sélectionnez ci-dessous le type de champs personnalisés que vous souhaitez ajouter"
    }
  },
  "secondaryCriteriaForm": {
    "linkForm": {
      "text": "Votre texte",
      "link": "Votre lien",
      "submit": "Envoyer"
    }
  },
  "units": {
    "time": {
      "day": {
        "symbol": {
          "singular": "J",
          "plural": "J"
        },
        "text": {
          "singular": "jour",
          "plural": "jours"
        }
      },
      "hour": {
        "symbol": {
          "singular": "h",
          "plural": "h"
        },
        "text": {
          "singular": "heure",
          "plural": "heures"
        }
      }
    },
    "currency": {
      "euro": {
        "symbol": {
          "singular": "€",
          "plural": "€"
        },
        "text": {
          "singular": "euro",
          "plural": "euros"
        }
      }
    }
  },
  "exports": {
    "projectBudget": {
      "project": "Projet",
      "createdAt": "le",
      "createdBy": "crée par",
      "projectBudgetSynthesis": {
        "title": "Budget",
        "plannedBudget": {
          "title": "Planifié",
          "headers": {
            "planned": "Planifié",
            "dateMonitoring": "Suivi à date",
            "total": "Total",
            "workload": "Travail"
          },
          "real": "Réel",
          "acquired": "Acquis",
          "planned": "Planifié",
          "budgetAllocated": "Budget alloué",
          "allocated": "Alloué",
          "past": "Passé",
          "remaining": "Reste à faire",
          "resource": "Ressource ",
          "expense": "Dépenses "
        },
        "workload": {
          "title": "Travail"
        },
        "expensesBreakdownByExpenseType": {
          "title": "Répartition des coûts par type de dépenses"
        },
        "costsBreakdownByResourceType": {
          "title": "Répartition des couts par type de ressources",
          "costs": "Coûts",
          "external": "Externes",
          "internal": "Internes",
          "material": "Matérielles"
        },
        "expenses": {
          "title": "Liste des dépenses",
          "create": "Dépense",
          "orderNumber": "N° Bon commande",
          "name": "Libellé",
          "expenseType": "Type",
          "quantity": "Qté",
          "unitAmount": "Montant U.",
          "totalAmount": "Montant total",
          "plannedDate": "Planifié",
          "actualDate": "Réel",
          "attachments": "Pièce(s) jointe(s)",
          "attachmentsAdd": "Ajouter"
        }
      }
    },
    "wbs": {
      "planzone": "Planzone",
      "zone": "Zone",
      "createdAt": "le",
      "createdBy": "crée par",
      "columnNames": {
        "type": "Type",
        "name": "Nom",
        "startDate": "Date de début",
        "endDate": "Date de fin",
        "duration": "Durée (jours)",
        "allocatedTime": "Alloué (heures)",
        "allocations": "Affecté(s)",
        "progress": "% de réalisation",
        "description": "Description",
        "statuses": "Statuts",
        "creationDate": "Date de création",
        "completionDate": "Date de complétion",
        "tags": "Tags"
      }
    },
    "resourceProjectAllocationReport": {
      "userName": "Nom d'utilisateur",
      "userEmail": "E-mail de l'utilisateur",
      "roleInProject": "Rôle dans le projet",
      "userStatus": "Statut de l'utilisateur",
      "projectName": "Nom du projet",
      "projectStatus": "Statut du projet",
      "projectZone": "Zone du projet",
      "projectStartDate": "Date de début du projet",
      "projectEndDate": "Date de fin du projet",
      "year": "Année",
      "month": "Mois",
      "allocatedTime": "Temps alloué",
      "spentTime": "Temps passé",
      "maxCompletionDate": "Date limite de réalisation"
    },
    "customCpamReport": {
      "month": "Mois",
      "openVersions": "Nombre de versions ouvertes",
      "mepVersions": "Nombre de versions en MEP",
      "documentationUpToDate": "Documentation à jour",
      "delayActiveProjects": "% Retard sur les projets en cours",
      "delayClosedProjects": "% Retard sur les projets clos"
    },
    "projectReports": {
      "planzone": "Planzone",
      "zone": "Zone",
      "author": "Auteur",
      "name": "Nom",
      "submissionDate": "Date de début"
    },
    "resourcesReport": {
      "worksheetName": "Ressources planzone",
      "planzone": "Planzone",
      "zone": "Zone",
      "createdAt": "le",
      "createdBy": "crée par",
      "type": "Type",
      "name": "Nom",
      "deactivated": "Désactivé",
      "address": "Adresse",
      "role": "Rôle",
      "function": "Fonction dans l’organisation",
      "description": "Description",
      "group": "Groupe",
      "tags": "Tags"
    },
    "timeSheetsReport": {
      "planzone": "Planzone",
      "zone": "Zone",
      "createdAt": "à",
      "createdBy": "par",
      "startDate": "de",
      "endDate": "à",
      "project": "Projet",
      "name": "Nom de la ressource",
      "deactivated": "Désactivé",
      "function": "Fonction dans l’organisation",
      "language": "fr-FR",
      "total": "Total",
      "allocatedHours": "Heures allouées",
      "reportTypeView": {
        "month": "Mensuelle",
        "week": "Hebdomadaire",
        "day": "Journalière"
      },
      "status": {
        "deactivated": "désactivée",
        "activated": "active"
      }
    },
    "ganttReport": {
      "planzone": "Planzone",
      "createdAt": "le",
      "gantt": "Gantt de",
      "endDateGantt": "a",
      "type": "Type",
      "name": "Nom",
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "progress": "% de réalisation",
      "language": "fr-FR",
      "allocatedTime": "Alloué (heures)",
      "allocations": "Affecté(s)",
      "views": {
        "weekly": "Vue hebdomadaire",
        "daily": "Vue journalière",
        "monthly": "Vue mensuelle",
        "yearly": "Vue annuelle"
      },
      "week": "S",
      "monthsName": {
        "january": "Janvier",
        "february": "Février",
        "march": "Mars",
        "april": "Avril",
        "may": "Mai",
        "june": "Juin",
        "july": "Juillet",
        "august": "Août",
        "september": "Septembre",
        "october": "Octobre",
        "november": "Novembre",
        "december": "Décembre"
      },
      "ganttType": {
        "complete": "Détaillé",
        "simple": "Simple"
      }
    },
    "resourceUsageReport": {
      "planzone": "Planzone",
      "createdAt": "le",
      "startReport": "de",
      "endDateReport": "a",
      "resource": "Ressource"
    },
    "resourceAllocatedTimeReport": {
      "planzone": "Planzone",
      "createdAt": "le",
      "startReport": "de",
      "endDateReport": "a",
      "resource": "Ressource"
    },
    "taskBudgetReport": {
      "planzone": "Planzone",
      "createdBy": "Exporté par",
      "createdAt": "le",
      "startDate": "Période du",
      "endDate": "au",
      "fromOrigin": "Depuis l'origine",
      "element": "Activité / Tâche",
      "allocated": "Alloué",
      "spent": "Passé",
      "remaining": "Restant",
      "total": "Total général",
      "emptySheet": "Aucun projet"
    },
    "timeSheetsByTaskReport": {
      "planzone": "Planzone",
      "zone": "Zone",
      "createdAt": "à",
      "createdBy": "par",
      "startDate": "de",
      "endDate": "à",
      "project": "Projet",
      "name": "Nom de la ressource",
      "deactivated": "Désactivé",
      "function": "Fonction dans l’organisation",
      "language": "fr-FR",
      "dateFormats": "dd/MM/yyyy",
      "total": "Total",
      "task": "Tâches",
      "lastDaySaved": "Dernier jour sauvegardé",
      "lastDayOfRecording": "Dernier jour d'enregistrement",
      "allocatedHours": "Heures allouées",
      "reportTypeView": {
        "month": "Mensuelle",
        "week": "Hebdomadaire",
        "day": "Journalière"
      },
      "status": {
        "deactivated": "désactivée",
        "activated": "active"
      },
      "tags": "tags"
    },
    "zonesProjectReport": {
      "planzone": "Planzone",
      "createdAt": "le",
      "createdBy": "crée par",
      "name": "Nom",
      "zoneHeader": {
        "zone": "Portefeuille",
        "weather": "Météo",
        "avgScore": "Score strat.",
        "averageDone": "MOY Réalisé",
        "averageDelayed": "MOY Retard",
        "averageOpend": "MOY Ouvert",
        "allocatedTime": "Alloué",
        "spentTime": "Passé",
        "remainingWork": "Reste à faire",
        "plannedBudget": "Planifié",
        "realCosts": "Coûts réels",
        "acquiredValue": "Valeur acq."
      },
      "projectHeader": {
        "projectName": "Nom du projet",
        "startDate": "Date de début",
        "endDate": "Date de fin",
        "description": "Description",
        "status": "Statut",
        "weather": "Météo",
        "avgScore": "Score Strat.",
        "activityMonitoring": {
          "title": "Suivi de l'activité",
          "done": "Réalisé",
          "delayed": "Retard",
          "opened": "Ouvert"
        },
        "workload": {
          "title": "Travail",
          "allocatedTime": "Alloué",
          "spentTime": "Passé",
          "remainingWork": "Reste à faire",
          "remainingWorkShort": "RàF"
        },
        "budget": {
          "title": "Budget",
          "plannedBudget": "Planifié",
          "realCosts": "Coûts réels",
          "acquiredValue": "Valeur acq."
        }
      },
      "projectStatuses": {
        "pz_closed": "Clos",
        "pz_waiting": "Interrompu",
        "pz_candidate": "Demandé",
        "pz_open": "Ouvert"
      },
      "graphsSheet": "Graphiques",
      "graphsTitle": "Projets par statut"
    },
    "projectPortfoliosReport": {
      "planzone": "Planzone",
      "createdAt": "le",
      "createdBy": "crée par",
      "name": "Nom",
      "zoneHeader": {
        "zone": "Zone",
        "weather": "Météo",
        "avgScore": "Score strat.",
        "averageDone": "MOY Réalisé",
        "averageDelayed": "MOY Retard",
        "averageOpend": "MOY Ouvert",
        "allocatedTime": "Alloué",
        "spentTime": "Passé",
        "remainingWork": "Reste à faire",
        "plannedBudget": "Planifié",
        "realCosts": "Coûts réels",
        "acquiredValue": "Valeur acq."
      },
      "projectHeader": {
        "projectName": "Nom du projet",
        "startDate": "Date de début",
        "endDate": "Date de fin",
        "description": "Description",
        "status": "Statut",
        "weather": "Météo",
        "avgScore": "Score Strat.",
        "activityMonitoring": {
          "title": "Suivi de l'activité",
          "done": "Réalisé",
          "delayed": "Retard",
          "opened": "Ouvert"
        },
        "workload": {
          "title": "Travail",
          "allocatedTime": "Alloué",
          "spentTime": "Passé",
          "remainingWork": "Reste à faire",
          "remainingWorkShort": "RàF"
        },
        "budget": {
          "title": "Budget",
          "plannedBudget": "Planifié",
          "realCosts": "Coûts réels",
          "acquiredValue": "Valeur acq."
        }
      },
      "projectStatuses": {
        "pz_closed": "Clos",
        "pz_waiting": "Interrompu",
        "pz_candidate": "Demandé",
        "pz_open": "Ouvert"
      }
    }
  },
  "taskStatuses": {
    "pr_done": "Terminé",
    "pr_in_progress": "En cours",
    "pr_todo": "À faire"
  },
  "projectStatuses": {
    "pz_closed": "Clos",
    "pz_waiting": "Interrompu",
    "pz_candidate": "Demandé",
    "pz_open": "Ouvert",
    "description": {
      "pz_closed": "Le projet clôturé est conservé pour archive.",
      "pz_waiting": "Le projet est interrompu et ne peut plus être édité.",
      "pz_candidate": "Le projet nécessite une validation avant de pouvoir passer à l'état ouvert.",
      "pz_open": "Le projet est en cours de réalisation. Celui-ci est éditable."
    }
  },
  "roles": {
    "pz_admin": "Administrateur",
    "pz_under_admin": "Créateur de projet",
    "pz_user": "Usager",
    "pz_visitor": "Visiteur",
    "pr_visitor": "Observateur",
    "pr_manager": "Chef(fe) de projet",
    "pr_worker": "Collaborateur",
    "description": {
      "pz_admin": "Gère les paramètres globaux, peut créer, consulter, modifier et supprimer tous les projets de la Planzone",
      "pz_under_admin": "Peut créer et paramétrer des projets dans les Zones. N’a la vision que sur ses propres projets ainsi que ceux sur lequel il est affecté.",
      "pz_user": "Accède aux zones et projets sur lesquels on l’affecte. Ses possibilités d’actions sur un projet dépendront du rôle projet attribué.",
      "pz_visitor": "Accède aux zones et projets sur lesquels on l’affecte en lecture uniquement. Accède aux fonctionnalités de gestion documentaire et de discussion",
      "pr_visitor": "Accède aux différentes vues du projet en lecture seule.",
      "pr_manager": "Planifie, alloue les ressources sur les tâches et édite les détails du projet.",
      "pr_worker": "Accède aux différentes vues du projet et réalise les tâches confiées."
    }
  },
  "milestoneStatuses": {
    "TODO": "À faire",
    "DONE": "Terminé"
  },
  "search": {
    "title": "Projets récents",
    "placeholder": "Rechercher"
  },
  "projectsList": {
    "label": "libellé",
    "taskStatus": "Statut du projet",
    "projectChief": "Chef de projet",
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "weather": "Météo",
    "reports": "Rapports"
  },
  "notifications": {
    "at": "à",
    "placeholder": "Vous n'avez aucune notification",
    "mentionInComment": {
      "commented": "à commenté",
      "seeMore": "Voir plus"
    },
    "replyToComment": {
      "replied": "a répondu à votre commentaire",
      "seeMore": "Voir plus"
    },
    "addedToTask": {
      "assigned": "vous a affecté(e) sur la tâche"
    },
    "addedToEvent": {
      "assigned": "vous a invité(e) à participer à l’événement"
    },
    "addedToProject": {
      "assigned": "vous a affecté(e) sur le projet"
    },
    "delayedTask": {
      "task": "La tâche",
      "is": "est",
      "delayed": "en retard"
    },
    "exportBiFinished": {
      "title": "Export BI",
      "status": "Votre export BI est",
      "seeExport": "Voir l'export"
    },
    "seeAll": "Voir toutes les notifications"
  },
  "navigation": {
    "dashboard": "Synthèse",
    "projects": "Projets",
    "tasks": "Tâches",
    "contacts": "Contacts"
  },
  "logIn": {
    "title": "Me connecter",
    "subTitle": "Je possède une Planzone ou j'ai été invité à rejoindre une Planzone",
    "emailLabel": "Votre adresse mail",
    "emailPlaceholder": "Email de votre entreprise",
    "passwordLabel": "Votre mot de passe",
    "passwordPlaceholder": "Entrez votre mot de passe",
    "authenticate": "Me connecter"
  },
  "registration": {
    "title": "Démarrez votre essai de 30 jours gratuitement",
    "subTitle": "En quelques clics, aucune carte de crédit requise",
    "lastNameTitle": "Nom",
    "lastNamePlaceholder": "Nom",
    "firstNameTitle": "Prénom",
    "firstNamePlaceholder": "Prénom",
    "emailTitle": "Email professionnel",
    "emailPlaceholder": "Adresse email valide",
    "phoneNumberTitle": "Numéro de téléphone",
    "phoneNumberPlaceholder": "Numéro de téléphone",
    "teamTitle": "Taille de votre équipe",
    "teamPlaceholder": "Veuillez sélectionner une option",
    "projectDescriptionTitle": "Quelques mots sur votre projet",
    "projectDescriptionPlaceholder": "Description",
    "consent": "En cliquant sur le bouton ci-dessous, vous consentez à accepter nos",
    "legalMentions": "Conditions d'utilisations",
    "submit": "Commencer gratuitement",
    "plans": {
      "basic": "Basic",
      "team": "Team",
      "business": "Business",
      "enterprise": "Enterprise",
      "enterprisePremium": "Enterprise+"
    }
  },
  "fillAccount": {
    "title": "Créez votre compte",
    "message": "Bonjour {{-fullName}}, pour confirmer votre inscription, saisissez votre mot de passe.",
    "password": {
      "label": "Mot de passe*",
      "placeholder": "12 caractères, 1 majuscule et 1 caractère spécial au minimum"
    },
    "submit": "Rejoindre la Planzone",
    "redirection": {
      "title": "Vous avez déjà validé votre inscription",
      "message": "Vous pouvez cliquer sur le lien ci-dessous pour vous connecter",
      "redirect": "Se connecter"
    },
    "errors": {
      "tooShort": "Le mot de passe doit comporter au moins 12 caractères.",
      "specialCharsOrNum": "Le mot de passe doit comporter au moins un chiffre ou un caractère spécial.",
      "upper": "Le mot de passe doit comporter au moins une majuscule.",
      "mismatchedConfirmation": "La confirmation de votre mot de passe ne correspond pas à votre mot de passe."
    }
  },
  "accountCreationConfirmation": {
    "usernameTitle": "Nom de compte",
    "usernamePlaceholder": "Nom",
    "passwordTitle": "Mot de passe",
    "passwordPlaceholder": "Mot de passe",
    "passwordConfirmationTitle": "Confirmation",
    "passwordConfirmationPlaceholder": "Confirmation",
    "companyTitle": "Nom de votre société",
    "companyPlaceholder": "Société",
    "titleTitle": "Votre position",
    "titlePlaceholder": "Veuillez sélectionner",
    "addressTitle": "Votre adresse",
    "addressPlaceholder": "Adresse",
    "planzoneNameTitle": "Nom de la Planzone",
    "planzoneNamePlaceholder": "Nom de la Planzone",
    "planzoneDomainTitle": "Url de votre Planzone",
    "planzoneDomainPlaceholder": "Url de votre Planzone",
    "submit": {
      "createPlanzone": "Je crée ma Planzone",
      "createAccount": "Je crée mon compte"
    },
    "accountTitle": "Finalisez votre inscription",
    "submitAccountForm": "Étape 2",
    "planzoneTitle": "Nommez votre Planzone",
    "goBack": "Retour"
  },
  "wizardForm": {
    "title": "Étape",
    "next": "Suivant",
    "previous": "Précédent",
    "submit": "Envoyer"
  },
  "jobTitles": {
    "director": "Direction / Cadre supérieur",
    "manager": "Manager",
    "contributor": "Employé",
    "intern": "Étudiant / Stagiaire",
    "other": "Autre"
  },
  "taskRetrieval": {
    "allocations": {
      "resource": "Assigné(s)",
      "allocatedHours": "Alloué",
      "spentHours": "Passé",
      "progress": "Complétion",
      "placeholder": "Sélectionnez un collaborateur"
    },
    "constraint": "L'élément est contraint et ne peut pas être démarré",
    "startDate": "Début",
    "endDate": "Fin",
    "completionDate": "Réel",
    "description": "Description",
    "secondaryCriteria": "Champs personnalisés",
    "advancement": "Avancement",
    "status": "Statut",
    "type": "Tâche",
    "notifications": {
      "noTasksFound": "Aucune tache ne correspond à votre recherche"
    },
    "expenditureType": {
      "label": "Nature Budgétaire",
      "none": "Aucune",
      "capex": "Capex",
      "opex": "Opex"
    },
    "tags": "Tags"
  },
  "retrieveEvent": {
    "title": "Détails de l'événement",
    "startTime": "Début",
    "endTime": "Fin",
    "description": "Description",
    "participants": "Participants",
    "tags": "Tags",
    "secondaryCriteria": "Champs personnalisés",
    "copyUrl": "Copier le lien",
    "edit": "Éditer",
    "move": "Déplacer",
    "remove": "Supprimer"
  },
  "milestoneRetrieval": {
    "allocations": {
      "resource": "Assigné(s) à la tâche",
      "allocatedHours": "Heures allouées",
      "progress": "Avancée sur la tâche"
    },
    "constraint": "L'élément est contraint et ne peut pas être démarré",
    "startDate": "Début",
    "endDate": "Fin",
    "completionDate": "Réel",
    "secondaryCriteria": "Champs personnalisés",
    "description": "Description",
    "advancement": "Avancement de la tâche",
    "copyUrl": "Copier le lien",
    "move": "Déplacer",
    "remove": "Supprimer"
  },
  "taskForm": {
    "name": "Nom de la tâche",
    "rename": "Renommer",
    "description": "Description",
    "characters": "caractères"
  },
  "eventForm": {
    "name": "Nom de l'événement",
    "rename": "Renommer",
    "description": "Description",
    "characters": "caractères"
  },
  "milestoneForm": {
    "name": "Nom du jalon",
    "rename": "Renommer",
    "description": "Description",
    "characters": "caractères"
  },
  "listForm": {
    "name": "Nom de la liste",
    "rename": "Renommer",
    "description": "Description",
    "characters": "caractères"
  },
  "tagForm": {
    "placeholder": "Nouveau tag",
    "noTags": "Aucun tag",
    "submit": "Ajouter"
  },
  "landing": {
    "title": "Bienvenue",
    "message": "Prenez en main vos projets depuis votre mobile !",
    "subTitle": "📐📱📝",
    "start": "Commencer",
    "register": "Je n'ai pas de compte. S'inscrire"
  },
  "layout": {
    "navigation": {
      "synthesis": "Mon espace",
      "members": "Membres",
      "costProfiles": "Profils",
      "capacity": "Capacité",
      "workload": "Charge prévisionnelle",
      "occupancy": "Taux d'occupation",
      "management": "Gestion",
      "finances": "Finances",
      "resources": "Ressources",
      "obs": "Organigramme",
      "utilities": "Personnalisation",
      "portfolios": "Portefeuilles",
      "calendar": "Calendrier",
      "exportReports": "Rapports / Exports",
      "documents": "Documents",
      "assistant": "Assistant IA",
      "strategy": "Stratégie",
      "strategicAxes": "Axes stratégiques"
    },
    "notifications": {
      "noProjectsFound": "Aucun projet"
    }
  },
  "membersList": {
    "user": "Utilisateur",
    "title": "Intitulé du poste",
    "planzoneTeams": "Groupes globaux",
    "projectTeams": "Groupes locaux",
    "name": "Nom",
    "tags": "Tags",
    "role": "rôle dans le projet",
    "groupLength": "membres",
    "groupPlaceholder": "Vous n'avez aucune équipe. Ajouter une équipe.",
    "contextualMenu": {
      "toggle": "Plus",
      "edit": "Éditer",
      "remove": "Retirer",
      "delete": "Supprimer",
      "disable": "Désactiver",
      "activate": "Activer",
      "transfer": "Transférer les allocations"
    }
  },
  "personalSynthesis": {
    "welcome": "Bonjour {{- name }} \uD83D\uDC4B\uD83C\uDFFC",
    "milestonesList": {
      "title": "Prochains jalons",
      "placeholder": "Aucun jalon"
    },
    "planning": "Ma semaine",
    "status": {
      "title": "Mon statut",
      "subTitle": "Mes tâches",
      "doneTasksNumber": "Réalisées",
      "onGoingTasksNumber": "Ouvertes",
      "overDueTasksNumber": "En retard"
    },
    "navigation": {
      "synthesis": "Ma synthèse",
      "timeSheets": "Suivi temporel"
    },
    "sort": {
      "name": "Nom",
      "status": "Statut",
      "date": "Date de fin"
    },
    "resourceFilter": "Pour",
    "synthesisOf": "La synthèse de",
    "overDueTasks": "Tâches en retard",
    "upComingTasks": "Tâches à venir et ouvertes",
    "blockedTasksToggle": "Tâches bloquées",
    "doneTasks": "Tâches terminées",
    "myTasks": "Mes tâches",
    "done": "réalisées",
    "onGoing": "ouvertes",
    "overDue": "en retard"
  },
  "synthesis": {
    "emptyTasks": "Aucune tâche",
    "onGoingTasksTitle": "Tâches à venir",
    "overDueTasksTitle": "Tâches en retard",
    "newTasksTitle": "Nouvelles tâches"
  },
  "contacts": {
    "administratorsTitle": "Administrateurs",
    "membersTitle": "Membres",
    "visitorsTitle": "Invités"
  },
  "planning": {
    "today": "Aujourd'hui",
    "monday": "Lundi",
    "tuesday": "Mardi",
    "wednesday": "Mercredi",
    "thursday": "Jeudi",
    "friday": "Vendredi",
    "saturday": "Samedi",
    "sunday": "Dimanche"
  },
  "project": {
    "navigation": {
      "dashboard": "Synthèse",
      "tasks": "Tâches",
      "team": "Équipe"
    },
    "team": {
      "managers": "Chef de projet",
      "collaborators": "Collaborateurs",
      "visitors": "Invités"
    },
    "projectEvolution": {
      "title": "Évolution du projet",
      "projectOverDueTitle": "Le projet est",
      "projectOverDueDaysNbr": "jours en retards",
      "projectAdvanceTitle": "Le projet est",
      "projectAdvanceDaysNbr": "jours en avances",
      "message": "Le projet est dans les temps"
    },
    "milestonesList": {
      "title": "Prochain jalon"
    },
    "projectProgress": {
      "title": "État d’avancement",
      "milestonesCount": "{{ count }} jalons réalisés",
      "allocatedHours": "{{ hours }} heures allouées",
      "projectWithHours": "{{ hours }} avec heures",
      "projectWithoutHours": "{{ hours }} sans heures"
    },
    "statuses": {
      "creation": {
        "addStatus": "Ajouter un statut",
        "submit": "Enregistrer"
      }
    }
  },
  "projectDetails": {
    "title": "Détails du projet {{- name }}",
    "nameTitle": "Nom du projet",
    "namePlaceholder": "Nom du projet",
    "descriptionTitle": "Description",
    "startDateTitle": "Date de début",
    "endDateTitle": "Date de fin",
    "projectStatus": "Statut du projet",
    "projectPortfoliosList": "Portefeuille(s)",
    "tagsList": "Tag(s)",
    "secondaryCriteria": "Champs personnalisés",
    "redirectProject": "aller au projet",
    "budget": {
      "allocated": "Budget Alloué",
      "planned": "Budget Planifié",
      "tracking": "Suivi Réel",
      "margins": "Marges",
      "allocatedResourcesBudget": "Ressources",
      "allocatedExpensesBudget": "Dépenses",
      "allocatedBudget": "Total",
      "costs": "Coûts"
    },
    "statuses": {
      "title": "Paramètres des statuts de tâche",
      "message": "Ajoutez ou supprimez des statuts, attribuez des pourcentages de complétion"
    },
    "toolsConfiguration": {
      "title": "Vues",
      "label": "Tout activer",
      "parameters": {
        "synthesis": {
          "name": "Synthèse",
          "description": "Synthèse de la performance du projet"
        },
        "listsList": {
          "name": "Liste",
          "description": "Liste de tous les éléments du projet"
        },
        "gantt": {
          "name": "Gantt",
          "description": "Représente tous les éléments du projet sur un axe temporel"
        },
        "kanban": {
          "name": "Tableau",
          "description": "Liste vos tâches en fonction de leurs statuts"
        },
        "timeSheets": {
          "name": "Suivi temporel",
          "description": "Affiche les temps passés et le reste à faire des ressources"
        },
        "discussions": {
          "name": "Discussions",
          "description": "Toutes les discussions entre vous et vos collaborateurs"
        },
        "documents": {
          "name": "Documents",
          "description": "Liste et grille de tous les documents reliés à ce projet"
        },
        "budget": {
          "name": "Budget",
          "description": "Tableau de bord résumant tous les aspects budgétaires du projet"
        },
        "calendar": {
          "name": "Calendrier",
          "description": "Visualisez tous les événements, tâches et jalons du projet sur un calendrier"
        },
        "reports": {
          "name": "Rapports / Exports",
          "description": "Génère des rapports et exports du projet, comme le planning journalier"
        }
      }
    },
    "resources": {
      "title": "Ressources",
      "humanResources": "Membres",
      "virtualResources": "Membres virtuels",
      "materialResources": "Ressources matérielles"
    }
  },
  "projects": {
    "allProjects": "Vos projets",
    "tasksListsNbr": "{{ tasksNbr }} listes de tâches"
  },
  "profile": {
    "menu": {
      "preferences": "Paramètres personnels",
      "planzoneParameters": "Paramètres de la Planzone",
      "logOut": "Déconnexion"
    }
  },
  "taskCreation": {
    "title": "Création d'une tâche",
    "duplicateTitle": "Dupliquer la tâche ",
    "taskCreationForm": {
      "nameTitle": "Nommer la tâche",
      "namePlaceholder": "Nom de la tâche",
      "assignedMembersTitle": "Assigné à",
      "startDatePlaceholder": "Date de début",
      "endDatePlaceholder": "Date de fin",
      "projectSelectionPlaceholder": "Sélectionnez un projet",
      "inProject": "Dans le projet",
      "isHourAccurate": "Planifié à l'heure près"
    },
    "submit": "Créer",
    "duplicate": "Dupliquer",
    "cancel": "Annuler",
    "nameTitle": "Nommer la tâche",
    "namePlaceholder": "Donnez un nom à la tâche",
    "descriptionTitle": "Description",
    "descriptionPlaceholder": "",
    "startDateTitle": "Début",
    "startDatePlaceholder": "Choisir une date",
    "endDateTitle": "Fin",
    "endDatePlaceholder": "Choisir une date",
    "parentListTitle": "Fait partie de",
    "parentListPlaceholder": "Choisir une liste",
    "allocationsTitle": "Assigné à",
    "statusTitle": "Statut affiché",
    "teamMembersList": {
      "title": "Assigner un membre"
    },
    "allocations": {
      "assignees": "Assignés",
      "allocatedHours": "Heures allouées",
      "placeholder": "Choisir un/des participants",
      "hours": "heures"
    }
  },
  "calendarHolidays": {
    "creation": {
      "title": "Créer un calendrier personnalisé",
      "cancel": "Annuler",
      "submit": "Enregistrer",
      "nameTitle": "Nommer le calendrier",
      "namePlaceholder": "Nom de calendrier",
      "holidaysTitle": "jours fériés :",
      "addHoliday": "Ajouter",
      "holidayCreation": {
        "namePlaceholder": "Nom du jour férié",
        "datePlaceholder": "Choisir une date"
      }
    },

    "removal": {
      "title": "Êtes-vous sûr de vouloir supprimer ce calendrier ?",
      "confirmation": "Le calendrier sera supprimé et retiré de la planzone.",
      "cancel": "Annuler",
      "confirm": "Supprimer"
    },
    "edition": {
      "title": "Éditer un Calendrier personnalisé",
      "cancel": "Annuler",
      "submit": "Mettre à jour",
      "nameTitle": "Nom du calendrier",
      "namePlaceholder": "Donnez un nom à le calendrier",
      "holidaysTitle": "jours fériés",
      "addHoliday": "Ajouter",
      "holidayEdition": {
        "namePlaceholder": "Nom",
        "datePlaceholder": "Choisir une date"
      }
    }
  },
  "eventCreation": {
    "title": "Création d'un événement",
    "submit": "Créer",
    "cancel": "Annuler",
    "nameTitle": "Nommer l'événement",
    "namePlaceholder": "Donnez un nom à l'événement",
    "descriptionTitle": "Description",
    "descriptionPlaceholder": "",
    "assignedMembersTitle": "Ajouter des participants",
    "startDateTitle": "Début",
    "startDatePlaceholder": "Sélectionner une date",
    "endDateTitle": "Fin",
    "endDatePlaceholder": "Sélectionner une date",
    "parentListTitle": "Fait partie de",
    "parentListPlaceholder": "Choisir une liste",
    "allocationsTitle": "Assigné à",
    "statusTitle": "Statut affiché",
    "selectAllDay": "Toute la journée",
    "projectSelectionPlaceholder": "Sélectionnez un projet",
    "inProject": "Dans le projet",
    "teamMembersList": {
      "title": "Assigner un membre"
    },
    "allocations": {
      "assignees": "Assignés",
      "allocatedHours": "Heures allouées",
      "placeholder": "Choisir un/des participants",
      "hours": "heures"
    }
  },
  "taskEdition": {
    "title": "Édition d'une tâche",
    "taskEditionForm": {
      "nameTitle": "Nommer la tâche",
      "namePlaceholder": "Nom de la tâche",
      "assignedMembersTitle": "Assigné à",
      "startDatePlaceholder": "Date de début",
      "endDatePlaceholder": "Date de fin",
      "projectSelectionPlaceholder": "Sélectionnez un projet"
    },
    "submit": "Enregistrer les modifications",
    "teamMembersList": {
      "title": "Assigner un membre"
    }
  },
  "dateTimeQuickSelection": {
    "today": "Aujourd'hui",
    "tomorrow": "Demain",
    "nextWeek": "Semaine prochaine",
    "nextMonth": "Mois prochain",
    "nextYear": "Année prochaine"
  },
  "dateTimeInput": {
    "projectTimezoneTitle": "Saisie en heure du projet ({{timezone}})"
  },
  "error": {
    "title": "Une erreur inconnue est survenue",
    "message": "Appuyer sur le bouton ci-dessous pour recharger cette page. Si le problème persiste, contactez-nous sur",
    "contactMail": "support@planzone.com",
    "retry": "Réessayer"
  },
  "zones": {
    "allZones": "Mes zones",
    "name": "Libellé",
    "seeZone": "Voir le détail de la zone",
    "addZone": "+ zone",
    "allZone": "Tout",
    "zonesPlaceholder": "Aucune zone pour le moment. Créez votre première zone pour commencer à organiser vos projets."
  },
  "zoneRemoval": {
    "title": "Êtes-vous sûr de vouloir supprimer cette zone ?",
    "message": "La suppression de la zone",
    "message2": "entrainera la suppression de tous les projets qu'elle contient.",
    "confirm": "Supprimer",
    "cancel": "Annuler",
    "tasks": "tâche(s)",
    "noProjectsFound": "Aucun projet"
  },
  "constraintRemoval": {
    "title": "Êtes-vous sûr de vouloir supprimer cette contrainte ?",
    "message": "La suppression de votre contrainte est définitive.",
    "confirm": "Supprimer",
    "cancel": "Annuler"
  },
  "projectsTransfer": {
    "title": "Zone de destination",
    "projects": {
      "selectAll": "Tout sélectionner",
      "title": "Sélectionner un ou plusieurs projets à déplacer"
    },
    "message": "Choisissez une zone vers laquelle transférer ces projets",
    "confirm": "Transférer",
    "cancel": "Annuler",
    "success": {
      "title": "Succès",
      "message": "Les projets de la zone \"{{- srcName }}\" ont été transférés avec succès vers la zone \"{{- dstName }}\"",
      "confirm": "Ok"
    }
  },
  "zone": {
    "projects": "Projets",
    "discussions": "Messages",
    "tasks": "Tâches",
    "close": "Fermer le détail",
    "resources": "Ressources",
    "edit": "Éditer",
    "remove": "Supprimer",
    "transfer": "Transférer les projets",
    "error": "Une erreur est survenue",
    "goToZone": "Aller sur la zone"
  },
  "calendarExportLinks": {
    "title": "Gestion des liens d'exportation du calendrier",
    "meOnly": "Seulement mes éléments",
    "everyone": "Tous les éléments"
  },

  "zoneCreation": {
    "nameTitle": "Nom de la zone",
    "namePlaceholder": "Entrez le nom de la zone",
    "descriptionTitle": "Description de la zone",
    "descriptionPlaceholder": "Entrez la description de la zone",
    "colorTitle": "Sélectionnez la couleur de votre zone",
    "title": "Créer une nouvelle zone",
    "submit": "Créer",
    "cancel": "Annuler"
  },
  "startDiscussion": {
    "title": "Créer un nouveau fil de discussion",
    "subject": "Sujet",
    "comment": "Votre commentaire",
    "recipients": "Envoyer par email à",
    "submit": "Créer",
    "cancel": "Annuler"
  },
  "folderCreation": {
    "title": "Créer un nouveau dossier",
    "nameTitle": "Nom (requis)",
    "namePlaceholder": "Nommer le dossier",
    "descriptionTitle": "Description",
    "descriptionPlaceholder": "",
    "parentFolderTitle": "Dossier principal",
    "parentFolderPlaceholder": "Choisir un dossier principal",
    "folderSelection": {
      "root": "Racine"
    },
    "submit": "Créer",
    "cancel": "Annuler"
  },
  "selectDocuments": {
    "title": "Importer des fichiers",
    "folders": "Dossiers",
    "documents": "Fichiers",
    "uploadDocument": "Charger un fichier",
    "selectedDocuments": "éléments sélectionnés",
    "selectedDocument": "élément sélectionné",
    "resetSelection": "Effacer la sélection",
    "folderCard": {
      "element": "element",
      "elements": "elements"
    },
    "submit": "Importer",
    "cancel": "Annuler"
  },
  "zoneEdition": {
    "title": "Détails de la zone {{- name }}",
    "descriptionPlaceholder": "Description",
    "save": "Enregistrer",
    "cancel": "Annuler"
  },
  "projectCreation": {
    "zoneSelectionPlaceholder": "Sélectionner une zone",
    "projectTypeChoice": {
      "title": "Créer un nouveau projet",
      "subTitle": "Comment voulez-vous créer votre projet ?",
      "project": {
        "title": "Depuis zéro",
        "description": "Créez et personnalisez votre projet depuis une base nouvelle"
      },
      "projectModel": {
        "title": "À partir d’un modèle",
        "description": "Gagnez du temps à l’aide d’un modèle de projet pré-défini"
      }
    },
    "title": "Créer un projet de zéro",
    "projectModelTitle": "Créer un modèle de projet",
    "nameTitle": "Nom du projet",
    "namePlaceholder": "Entrez le nom du projet",
    "descriptionTitle": "Description",
    "descriptionPlaceholder": "Entrez la description du projet",
    "cancel": "Annuler",
    "submit": "Créer",
    "datesTitle": "Dates",
    "startDateTitle": "Date de début",
    "startDatePlaceholder": "Choisir une date",
    "endDateTitle": "Date de fin",
    "statusTitle": "Statut du projet",
    "tagsTitle": "Ajouter des tags",
    "projectPortfoliosList": "Ajouter des portefeuilles",
    "endDatePlaceholder": "Choisir une date",
    "inZone": "Dans la zone",
    "descriptionMaxCharacter": " / 5000 caractères",
    "errorTitleInput": "Veuillez nommer votre projet"
  },
  "projectCreationFromModel": {
    "title": "Créer un projet à partir d’un modèle",
    "subTitle": "Choisissez un modèle de projet",
    "description": "Un modèle de projet vous permet de gagner du temps dans la création de nouveaux projets ayant une structure similaire.",
    "use": "Créer un projet",
    "cancel": "Annuler"
  },
  "projectCreationFromProjectModel": {
    "title": "Créer un projet à partir d’un modèle",
    "submit": "Créer",
    "cancel": "Annuler"
  },
  "projectDuplication": {
    "title": "Dupliquer un projet",
    "submit": "Créer",
    "cancel": "Annuler"
  },
  "projectModelCreationFromProject": {
    "title": "Créer un modèle à partir d’un projet",
    "submit": "Créer",
    "cancel": "Annuler"
  },
  "assistantPage": {
    "title": "Assistant IA"
  },
  "chatbot": {
    "header": {
      "title": "Planzone Intelligence"
    },
    "sidebar": {
      "title": "Historique",
      "empty": "Aucune conversation",
      "untitled": "Sans titre",
      "newConversation": "Nouvelle conversation",
      "resetMemory": "Réinitialiser la mémoire",
      "delete": "Supprimer",
      "collapse": "Replier l'historique",
      "expand": "Déplier l'historique"
    },
    "messages": {
      "empty": "Posez une question pour démarrer la conversation."
    },
    "input": {
      "placeholder": "Écrivez votre message...",
      "send": "Envoyer",
      "cancel": "Annuler"
    },
    "notification": {
      "title": "Nouvelle réponse",
      "body": "L'assistant a terminé sa réponse."
    },
    "error": "Une erreur est survenue pendant la génération de la réponse."
  },
  "chatConversationRemoval": {
    "title": "Êtes-vous sûr de vouloir supprimer cette conversation ?",
    "message": "La suppression de la conversation",
    "confirm": "Supprimer",
    "cancel": "Annuler"
  },
  "searchPage": {
    "title": "Résultats de recherche",
    "filters": {
      "name": "Rechercher..."
    },
    "types": {
      "anyType": "Tous les résultats",
      "project": "Projets",
      "task": "Tâches",
      "milestone": "Jalons"
    }
  },
  "unExpectedErrorPage": {
    "title": "Oups… Une erreur est survenue",
    "message": "Nos équipes ont été automatiquement informées et travaillent déjà à la résoudre.",
    "refresh": "Rafraîchir",
    "sendReport": "Envoyer le rapport"
  },
  "zonePage": {
    "projectDetails": "Détails",
    "move": "Déplacer",
    "filterForm": {
      "me": "Moi",
      "everyone": "Tout le monde",
      "filtersTitle": "Filtres",
      "open": "Trier par projets ouverts",
      "alphabetical": "Trier par ordre alphabétique"
    },
    "menu": {
      "details": "Détails de la zone",
      "remove": "Supprimer"
    },
    "navigation": {
      "project": "Projets",
      "synthesis": "Synthèse",
      "list": "Liste",
      "gantt": "Gantt",
      "kanban": "Tableau",
      "timeSheets": "Suivi temporel",
      "reports": "Comptes rendus",
      "workloads": "Charge",
      "calendar": "Calendrier"
    },
    "projects": {
      "title": "Projets de la zone",
      "average": "moy",
      "labels": {
        "projectName": "Nom du projet",
        "dates": "Dates",
        "startDate": "Début",
        "avgScore": "Score strat.",
        "score": "Score strat.",
        "endDate": "Fin",
        "status": "Statut",
        "weather": "Météo",
        "activityMonitoring": {
          "title": "Suivi de l'activité",
          "done": "Réalisé",
          "delayed": "Retard",
          "opened": "Ouvert"
        },
        "workload": {
          "title": "Travail",
          "allocatedTime": "Alloué",
          "spentTime": "Passé",
          "remainingWork": "Restant",
          "remainingWorkShort": "Restant"
        },
        "budget": {
          "title": "Budget",
          "plannedBudget": "Planifié",
          "realCosts": "Réel",
          "acquiredValue": "Acquis"
        }
      },
      "createProject": "Projet",
      "editZone": "Éditer",
      "removeZone": "Supprimer",
      "sorter": {
        "title": "Trier par :",
        "default": "Aucun tri",
        "ascendingAlphabeticalOrder": "A > Z",
        "descendingAlphabeticalOrder": "Z > A",
        "startDate": "Date de début",
        "endDate": "Date butoir",
        "completionDate": "Date de réalisation",
        "creationDate": "Date de création"
      },
      "filters": {
        "title": "Filtrer par :",
        "placeholderZone": "Tous les projets",
        "placeholderResource": "Tout le monde",
        "showProjectsOf": "Montrer les projets de"
      },
      "contextualMenu": {
        "projectDetails": "Détails du projet",
        "projectStatus": "Gérer les statuts",
        "createProjectModel": "Créer un modèle",
        "strategicImpact": "Impact stratégique",
        "move": "Déplacer",
        "remove": "Supprimer"
      }
    },
    "reportsPage": {
      "thisWeek": "Cette semaine",
      "thisMonth": "Ce mois-ci",
      "others": "Moins récent",
      "author": "Créé par",
      "submissionDate": "Dernier rapport",
      "zone": "Zone",
      "sortOptions": {
        "title": "Trier par",
        "optionOne": "Le plus récent",
        "optionTwo": "Le plus ancien"
      },
      "filterOptions": {
        "title": "Filtrer par",
        "button": "Effacer le filtre",
        "placeholder": "Rechercher",
        "projects": "Projets",
        "tags": "Tags projet",
        "allProjects": "Tous les projets",
        "placeholderResource": "Tout le monde"
      }
    },
    "createProject": "Projet"
  },
  "zonesPage": {
    "projectDetails": "Détails",
    "addProject": "Projet",
    "addZone": "Zone",
    "edit": "Éditer",
    "remove": "Supprimer",
    "navigation": {
      "zones": "Zones",
      "projects": "Projets",
      "list": "Liste",
      "gantt": "Gantt",
      "reports": "Comptes rendus",
      "workloads": "Charge"
    },
    "sort": {
      "title": "Trier par :",
      "latest": "Le plus récent",
      "oldest": "Le plus ancien"
    },
    "filter": {
      "title": "Filtrer par :",
      "placeholderZones": "Toutes les zones",
      "placeholderResources": "Tout le monde"
    },
    "zones": {
      "heading": {
        "zone": "Nom de la zone",
        "projectNbr": "Nombre de projets",
        "weather": "Météo"
      },
      "edit": "Éditer",
      "remove": "Supprimer"
    },
    "projects": {
      "title": "Projets de la zone",
      "zoneTitle": "{{name}} ({{count}})",
      "average": "moy",
      "labels": {
        "projectName": "Nom du projet",
        "dates": "Dates",
        "startDate": "Début",
        "avgScore": "Score strat.",
        "score": "Score strat.",
        "endDate": "Fin",
        "status": "Statut",
        "weather": "Météo",
        "activityMonitoring": {
          "title": "Suivi de l'activité",
          "done": "Réalisé",
          "delayed": "Retard",
          "opened": "Ouvert"
        },
        "workload": {
          "title": "Travail",
          "allocatedTime": "Alloué",
          "spentTime": "Passé",
          "remainingWork": "Restant",
          "remainingWorkShort": "Restant"
        },
        "budget": {
          "title": "Budget",
          "plannedBudget": "Planifié",
          "realCosts": "Réel",
          "acquiredValue": "Acquis"
        }
      },
      "createProject": "Projet",
      "editZone": "Éditer",
      "removeZone": "Supprimer",
      "sorter": {
        "title": "Trier par :",
        "default": "Aucun tri",
        "ascendingAlphabeticalOrder": "A > Z",
        "descendingAlphabeticalOrder": "Z > A",
        "startDate": "Date de début",
        "endDate": "Date butoir",
        "completionDate": "Date de réalisation",
        "creationDate": "Date de création"
      },
      "filters": {
        "title": "Filtrer par :",
        "placeholderZone": "Tous les projets",
        "placeholderResource": "Tout le monde",
        "showProjectsOf": "Montrer les projets de"
      },
      "contextualMenu": {
        "projectDetails": "Détails du projet",
        "projectStatus": "Gérer les statuts",
        "createProjectModel": "Créer un modèle",
        "strategicImpact": "Impact stratégique",
        "move": "Déplacer",
        "remove": "Supprimer"
      }
    },
    "reportsPage": {
      "thisWeek": "Cette semaine",
      "thisMonth": "Ce mois-ci",
      "others": "Moins récent",
      "author": "Créé par",
      "submissionDate": "Dernier rapport",
      "zone": "Zone"
    }
  },
  "listRetrieval": {
    "tasks": "tâches",
    "startDate": "Début",
    "endDate": "Fin",
    "description": "Description",
    "copyUrl": "Copier le lien",
    "secondaryCriteria": "Champs personnalisés",
    "edit": "Éditer",
    "move": "Déplacer",
    "remove": "Supprimer"
  },
  "planzoneParametersPage": {
    "title": "Paramètres de la Planzone",
    "organization": {
      "title": "Informations sur l'organisation",
      "name": "Nom de l'entité",
      "type": "Type",
      "mainAddress": "Adresse principale",
      "street": "Rue",
      "zipCode": "Code postal",
      "city": "Ville",
      "state": "Commune",
      "country": "Pays",
      "read": "Annuler",
      "write": "Modifier",
      "submit": "Enregistrer"
    },
    "timeAllocation": {
      "title": "Possibilités de saisie des temps :",
      "description": "Définissez dans ce tableau quelles sont les vues de suivi temporel permettant la saisie des temps :",
      "personalTimeSheet": "Suivi temporel personnel",
      "groupTimeSheet": "Suivi temporel du projet (accessible aux chefs de projets uniquement)",
      "managerTimeSheet": "Responsable de saisie des temps (paramétrables depuis la fiche ressource)",
      "entry": "Saisie",
      "approval": "Validation"
    },
    "settings": {
      "title": "Préférences",
      "sections": {
        "timeTracking": "Suivi du temps",
        "planning": "Planification",
        "collaboratorPermissions": "Permissions du rôle projet collaborateur",
        "system": "Système"
      },
      "lockWeeklyCalendarForNonAdmin": "Désactiver l’édition du calendrier de travail pour les non administrateurs",
      "hideProjectStatsInProjectListing": "Masquer les indicateurs de suivi d’activité et de travail dans les vues portefeuilles, liste des projets d’une zone et liste des projets de la Planzone pour les non-administrateurs",
      "areTimeSheetsAutoIntegrated": "Activer l'intégration automatique des feuilles de temps",
      "areUsersNotifiedAfterAccountCreation": "Envoyer un mail d’invitation automatique à l’invitation d’un nouveau membre",
      "workersCanCreateTask": "Les collaborateurs dans un projet peuvent créer une tâche",
      "workersCanEditTask": "Les collaborateurs dans un projet peuvent éditer une tâche",
      "workersCanRemoveTask": "Les collaborateurs dans un projet peuvent supprimer une tâche",
      "workersCanCreateList": "Les collaborateurs dans un projet peuvent créer une liste",
      "workersCanEditList": "Les collaborateurs dans un projet peuvent éditer une liste",
      "workersCanRemoveList": "Les collaborateurs dans un projet peuvent supprimer une liste",
      "workersCanCreateMilestone": "Les collaborateurs dans un projet peuvent créer un jalon",
      "workersCanEditMilestone": "Les collaborateurs dans un projet peuvent éditer un jalon",
      "workersCanRemoveMilestone": "Les collaborateurs dans un projet peuvent supprimer un jalon",
      "workersCanCreateEvent": "Les collaborateurs dans un projet peuvent créer un événement",
      "workersCanEditEvent": "Les collaborateurs dans un projet peuvent éditer un événement",
      "workersCanRemoveEvent": "Les collaborateurs dans un projet peuvent supprimer un événement",
      "conserveElementDuration": "Déplacer un élément de projet sur une période non ouvrée prolongera sa durée d’un nombre de jours correspondant au total des jours non ouvrés inclus dans cette période",
      "showTaskCompletionPercentage": "Afficher le pourcentage d'avancement des tâches dans les feuilles de temps",
      "enterTimeAllocationInDays": "Saisir l'allocation de temps en jours.",
      "allowDataScrapingForDebug": "Nous autorisez-vous à récupérer les rapports d'erreur pour dépanner votre Planzone ?",
      "enableSelfAssignmentButton": "Activer le bouton d'auto-affectation sur une tâche de la Planzone dans le suivi temporel personnel pour tous les utilisateurs de la planzone",
      "syncAllocationDurationWithTask": "Lier les heures allouées à la durée de la tâche",
      "lockBeforeIntegrationDate": "Bloquer la saisie du temps aux dates intégrées",
      "warnOnDailyCriticalAmplitude": "Afficher un warning lorsque la ou les ressources dépassent une amplitude journalière de travail critique",
      "warnOnDailyCriticalVolume": "Afficher un warning lorsque la ou les ressources dépassent un volume de travail journalier critique",
      "warnOnInsufficientRestPeriod": "Alerte si le repos entre la fin de la dernière activité et le début de la première du lendemain est inférieur au seuil configuré",
      "warnOnUnavailability": "Afficher un avertissement lorsqu'une ressource affectée est en indisponibilité sur la période de la tâche"
    },
    "areaRestrictions": {
      "title": "Vues"
    },
    "calendarHolidays": {
      "title": "Calendriers de jours fériés",
      "subTitleDefaultCalendar": "Calendrier de jours fériés par défaut",
      "subTitle": "Calendriers personnalisés",
      "submit": "Ajouter un calendrier",
      "placeholder": "Choisir",
      "defaultHint": "Appliqué automatiquement aux nouveaux projets de la planzone.",
      "holidaysCountSingular": "{{count}} jour férié",
      "holidaysCountPlural": "{{count}} jours fériés",
      "noHolidays": "Aucun jour férié",
      "emptyState": "Aucun calendrier personnalisé pour le moment.",
      "defaultBadge": "Par défaut",
      "editAction": "Renommer le calendrier",
      "removeAction": "Supprimer le calendrier"
    },
    "logs": {
      "title": "Logs",
      "redirection": "Accéder aux logs"
    },
    "resourceUsageReport": {
      "title": "Rapport d'utilisation de Planzone",
      "subTitle": "Rapport des connexion des utilisateurs sur la Planzone courante par jour",
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "download": "Télécharger"
    },
    "identityProviders": {
      "title": "SSO",
      "cas": {
        "loginUrl": {
          "label": "Login URL",
          "placeholder": "Login URL"
        },
        "protocol": {
          "label": "Protocol",
          "placeholder": "Protocol"
        },
        "clientName": {
          "label": "Client name",
          "placeholder": "Client name"
        },
        "enabled": "Activé"
      },
      "azure": {
        "clientId": {
          "label": "Client ID",
          "placeholder": "Client ID"
        },
        "clientSecret": {
          "label": "Client secret",
          "placeholder": "Client secret"
        },
        "tenant": {
          "label": "Tenant",
          "placeholder": "Tenant"
        },
        "discoveryUri": {
          "label": "Discovery URI",
          "placeholder": "Discovery URI"
        },
        "scope": {
          "label": "Scope",
          "placeholder": "Scope"
        },
        "callbackUrlType": {
          "label": "Callback url type",
          "placeholder": "Callback url type"
        },
        "loginUrl": {
          "label": "Login URL",
          "placeholder": "Login URL"
        },
        "clientName": {
          "label": "Client name",
          "placeholder": "Client name"
        },
        "displayName": {
          "label": "Display name",
          "placeholder": "Display name"
        },
        "principalAttributeId": {
          "label": "Principal attribute id",
          "placeholder": "Principal attribute id"
        },
        "enabled": "Activé"
      },
      "tutorial": {
        "message": "Vous n'avez pas configuré votre SSO. Voulez vous configurer votre SSO ?",
        "configure": "Configurer"
      },
      "addProvider": "Ajouter",
      "remove": "Supprimer",
      "edit": "Modifier"
    },
    "api": {
      "title": "API",
      "link": "Accès API"
    },
    "timesheetDeadline": {
      "title": "Date limite de saisie des temps",
      "description": "Définissez une date à laquelle les temps passés ne pourront plus être modifiés ou saisis.",
      "placeholder": "Sélectionner une date et heure"
    }
  },
  "documentsPage": {
    "title": "Documents",
    "reportsPage": {
      "filters": {
        "show": "Montrer",
        "author": "Filtrer par",
        "date": "Trier par",
        "resetFilter": "Réinitialiser les filtres",
        "newestReportsFilter": "Le plus récent",
        "oldestReportsFilter": "Le plus ancien",
        "all": "Tout"
      },
      "header": {
        "name": "Libellé",
        "submissionDate": "Date de soumission",
        "author": "Rapporteur",
        "indicators": "Indicateurs"
      },
      "remove": "Supprimer",
      "duplicate": "Dupliquer",
      "export": "Exporter"
    },
    "documentsPage": {
      "title": "Documents",
      "header": {
        "name": "Nom",
        "createdBy": "Créateur",
        "creationDate": "Date de création"
      },
      "elementCreationMenu": {
        "button": "Ajouter",
        "uploadDocument": "Fichier",
        "createFolder": "Dossier",
        "createDocx": "Docx",
        "createSlide": "Slide",
        "createPdf": "Pdf",
        "createExcel": "Excel"
      },
      "placeholder": {
        "title": "Votre espace de gestion documentaire est vide",
        "addElement": "Voulez-vous ajouter un élément ?"
      },
      "templateFolder": "Modèles de document",
      "download": "Télécharger",
      "rename": "Renommer",
      "remove": "Supprimer",
      "move": "Déplacer",
      "edit": "Modifier",
      "addToTemplates": "Créer Modèle"
    },
    "sideBar": {
      "reports": "Comptes rendus",
      "folder": "Fichiers"
    }
  },
  "planzoneMembersPage": {
    "title": "Liste des membres",
    "organizationalUnit": {
      "none": "Aucune unité"
    },
    "addResource": "Ressource",
    "addMaterialResource": "Ressource matérielle",
    "inviteMembers": "Inviter un membre",
    "addVirtualResource": "Ressource virtuelle",
    "groupsTitle": "groupes",
    "rolesTitle": "Tous les membres",
    "resourceTypesFilterTitle": "Ressources",
    "toggleView": "Groupes",
    "filters": {
      "title": "Filtrer par :",
      "default": "Aucun filtre",
      "button": "Effacer le filtre",
      "allProjects": "Tous les projets",
      "projectDropdown": "Projets",
      "tagDropdown": "Tags"
    },
    "sorters": {
      "title": "Trier par :",
      "default": "Aucun tri (par defaut)",
      "name": "Nom",
      "role": "Rôle",
      "creationDate": "Date d'entrée"
    },
    "resources": {
      "name": "Nom",
      "role": "Rôle",
      "tags": "Tags",
      "humanResource": "Humaines",
      "materialResource": "Matérielles",
      "virtualResource": "Virtuelles",
      "activeResource": "Actives",
      "inactiveResource": "Inactives",
      "invitationStatus": "Statut",
      "pending": "Invitation en attente",
      "subordinates": "Gère les temps de",
      "organizationalUnit": "Unité organisationnelle",
      "edit": "Éditer",
      "activate": "Activer",
      "disable": "Désactiver",
      "clearSubordinates": "Effacer"
    },
    "export": "Exporter",
    "workbookName": "Ressources_de_"
  },
  "projectResourcesPage": {
    "title": "Liste des membres",
    "addResource": "Ressource",
    "addMaterialResource": "Ressource matérielle",
    "addVirtualResource": "Ressource virtuelle",
    "toggleViewButton": "Groupes",
    "filters": {
      "sort": "Trier par :",
      "noSort": "Aucun tri (par défaut)",
      "lastNameSort": "Nom",
      "firstNameSort": "Prénom",
      "roleSort": "Rôle",
      "entryDateSort": "Date d'entrée",
      "filter": "Filtrer par :",
      "defaultFilter": "Tout"
    },
    "export": "Exporter",
    "workbookName": "Ressources_de_"
  },
  "capacityPage": {
    "title": "Capacité",
    "toolbar": {
      "monthlyView": "Vue mensuelle",
      "weeklyView": "Vue hebdomadaire",
      "sortTitle": "Trier par :",
      "filterTitle": "Filtrer :",
      "filterPlaceholder": "Toutes les ressources",
      "unit": "Unité",
      "helpTitle": "Capacité",
      "help": "Cette vue vous permet de consulter la <bold>disponibilité</bold> de vos ressources dans Planzone. Elle s’appuie par défaut sur le <bold>calendrier hebdomadaire individuel</bold> de chaque collaborateur, en décomptant automatiquement les <bold>jours fériés</bold> et les <bold>absences</bold>. Vous pouvez toutefois y ajouter des <bold>exceptions ponctuelles de capacité</bold> si nécessaire."
    },
    "sorters": {
      "alphabetical": "Alphabétique",
      "role": "Rôle",
      "creationDate": "Date de création",
      "type": "Type"
    },
    "table": {
      "resource": "Ressource"
    },
    "empty": "Aucune ressource à afficher.",
    "error": "Une erreur est survenue lors du chargement de la capacité.",
    "retry": "Réessayer"
  },
  "workloadPage": {
    "title": "Charge prévisionnelle",
    "toolbar": {
      "monthlyView": "Vue mensuelle",
      "weeklyView": "Vue hebdomadaire",
      "sortTitle": "Trier par :",
      "filterTitle": "Filtrer :",
      "filterPlaceholder": "Toutes les ressources",
      "unit": "Unité",
      "expandAll": "Tout déplier",
      "collapseAll": "Tout replier",
      "helpTitle": "Vue Charge prévisionnelle",
      "help": "Cette vue vous permet d’éditer la charge prévisionnelle de vos ressources sur leurs projets tout en gardant une visibilité directe sur leur capacité (affichées côte à côte : la charge à gauche, la capacité à droite).\n\n<bold>Remarque :</bold> La charge prévisionnelle est indépendante de la charge « classique » et n’intervient pas dans les calculs des vues de charge des vues <bold>Gantt</bold> et <bold>Charge</bold>."
    },
    "sorters": {
      "alphabetical": "Alphabétique",
      "role": "Rôle",
      "creationDate": "Date de création",
      "type": "Type"
    },
    "table": {
      "resource": "Ressource",
      "detailEmpty": "Aucun projet à afficher.",
      "detailError": "Une erreur est survenue lors du chargement du détail par projet."
    },
    "empty": "Aucune ressource à afficher.",
    "error": "Une erreur est survenue lors du chargement de la charge.",
    "retry": "Réessayer"
  },
  "occupancyPage": {
    "title": "Taux d'occupation",
    "toolbar": {
      "monthlyView": "Vue mensuelle",
      "weeklyView": "Vue hebdomadaire",
      "sortTitle": "Trier par :",
      "filterTitle": "Filtrer :",
      "filterPlaceholder": "Toutes les ressources",
      "expandAll": "Tout déplier",
      "collapseAll": "Tout replier",
      "helpTitle": "Vue Taux d’occupation",
      "help": "Cette vue vous permet d’analyser le <bold>taux d’occupation</bold> de vos ressources sur la période de votre choix, avec un découpage détaillé par projet.\n\nPour vous aider à identifier rapidement la <bold>sous-charge</bold> et la <bold>surcharge</bold>, un <bold>code couleur dynamique</bold> est appliqué :\n\n<green>Vert</green> : Charge inférieure ou égale à 100% (occupation optimale ou disponible).\n<orange>Orange</orange> : Charge comprise entre 101% et 130% (surcharge modérée à surveiller).\n<red>Rouge</red> : Charge supérieure à 130% (surcharge critique nécessitant un arbitrage)."
    },
    "sorters": {
      "alphabetical": "Alphabétique",
      "role": "Rôle",
      "creationDate": "Date de création",
      "type": "Type"
    },
    "table": {
      "resource": "Ressource",
      "overload": "Charge sans capacité",
      "detailEmpty": "Aucun projet à afficher.",
      "detailError": "Une erreur est survenue lors du chargement du détail par projet."
    },
    "empty": "Aucune ressource à afficher.",
    "error": "Une erreur est survenue lors du chargement du taux d'occupation.",
    "retry": "Réessayer"
  },
  "costProfilesPage": {
    "title": "Liste des profils de coûts",
    "add": "Profil",
    "name": "Nom",
    "affiliation": "Type",
    "costProfile": "Profil",
    "sidebar": {
      "allMembers": "Tous les membres",
      "internal": "Internes",
      "external": "Externes",
      "costProfiles": "Profils",
      "edit": "Éditer",
      "remove": "Supprimer"
    },
    "hour": "heure"
  },
  "createCostProfile": {
    "title": "Créer un nouveau profil de coût",
    "name": "Nom du profil (requis)",
    "cost": "Coût horaire",
    "costLabel": "€/heure",
    "description": "Description",
    "cancel": "Annuler",
    "submit": "Créer"
  },
  "duplicateList": {
    "title": "Dupliquer la liste {{-name}}",
    "message": "La liste est ses sous-éléments seront dupliqués",
    "cancel": "Annuler",
    "submit": "Dupliquer"
  },
  "editCostProfile": {
    "title": "Modifier un profil de coût",
    "name": "Nom du profil (requis)",
    "cost": "Coût horaire",
    "costLabel": "€/heure",
    "description": "Description",
    "cancel": "Annuler",
    "submit": "Modifier",
    "costProfileTitle": "Historique",
    "dailyCost": "Coût journalier",
    "costStartDate": "Date d'effet",
    "addCost": "Ajouter"
  },
  "projectPage": {
    "menu": {
      "projectDetails": "Détails du projet",
      "projectStatus": "Gérer les statuts",
      "createProjectModel": "Créer un modèle",
      "strategicImpact": "Impact stratégique",
      "move": "Déplacer",
      "duplicate": "Dupliquer",
      "secondaryCriteria": "Champs personnalisés locaux",
      "logs": "Logs du projet",
      "remove": "Supprimer"
    },
    "navigation": {
      "members": "Équipe",
      "discussions": "Discussions",
      "reports": "Documents",
      "budget": "Budget",
      "reportsExports": "Rapports"
    },
    "toggle": "Statut",
    "toggleList": "Liste",
    "elementCreationMenu": {
      "button": "Créer",
      "createList": "Liste de tâche",
      "createTask": "Tâche",
      "createEvent": "Événement",
      "createMilestone": "Jalon"
    },
    "tasks": "tâches",
    "list": "Liste",
    "subList": "Sous-liste",
    "tasksHeading": {
      "name": "Libellé",
      "tags": "Tags",
      "status": "Statut",
      "assignees": "Assigné à",
      "endDate": "Date de fin",
      "taskAdvancement": "Completion"
    },
    "tasksContextualMenu": {
      "copyUrl": "Copier le lien",
      "edit": "Éditer",
      "move": "Déplacer",
      "duplicate": "Dupliquer",
      "remove": "Supprimer"
    },
    "synthesisPage": {
      "milestones": {
        "title": "Jalons",
        "placeholder": "Aucuns jalons en retard ou à venir."
      },
      "monitoring": {
        "title": "Suivi de l’activité",
        "today": "Aujourd'hui",
        "doneTitle": "Réalisé",
        "overDueTitle": "Retard",
        "openedTitle": "Ouvert",
        "allocatedTime": "Alloué",
        "workedHours": "Passé",
        "openedWorkHours": "Reste à faire",
        "doneMilestones": "Jalons réalisés",
        "doneTasks": "Tâches complétées",
        "endDate": "Date de fin",
        "start": "Début",
        "end": "Fin",
        "fallBack": "Rien n'est planifié dans ce projet",
        "completionDate": "Date de complétion"
      },
      "overDueTasks": {
        "title": "Tâches en retard",
        "placeholder": "Aucune tâche en retard",
        "myPlaceholder": "Aucune tâche en retard pour vous"
      },
      "upComingTasks": {
        "title": "Tâches à venir",
        "placeholder": "Aucune tâche à venir",
        "myPlaceholder": "Aucune tâche à venir pour vous"
      },
      "tasks": {
        "me": "Moi",
        "everyone": "Tout le monde"
      },
      "latestReports": "Derniers comptes rendus",
      "submitFlashReport": "Rapport flash",
      "submitReport": "Faire un compte rendu",
      "strategicScore": "Score stratégique",
      "description": "Description",
      "reports": {
        "empty": "Il n'y a pas encore de compte rendu sur le projet",
        "header": {
          "name": "Libellé",
          "submissionDate": "Date",
          "author": "Rapporteur",
          "indicators": "Indicateurs"
        },
        "by": "par"
      },
      "pdfExport": {
        "title": "Rapport flash",
        "createdOn": "Créé le :",
        "by": "Par :",
        "in": "dans",
        "form": {
          "title": "Créer un rapport flash",
          "projectName": "Rapport flash du projet ",
          "object": "Objet",
          "addReport": "Inclure un compte rendu",
          "chooseReport": "Choisir un reporting",
          "noReport": "Vous n'avez aucun compte rendu dans le projet",
          "reportPlaceholder": "Sélectionner un compte rendu",
          "cancel": "Annuler",
          "submit": "Exporter",
          "generating": "Génération..."
        },
        "description": {
          "title": "Description du projet :"
        },
        "synthesis": {
          "title": "Informations sur le projet",
          "weather": "Météo",
          "owner": "Propriétaire",
          "startDate": "Début",
          "endDate": "Fin",
          "projectStatus": "Statut",
          "portfolio": "Portefeuille(s)",
          "strategicScore": "Score stratégique",
          "tags": "Tag(s)"
        },
        "secondaryCriteria": {
          "title": "Champs personnalisés"
        },
        "object": {
          "title": "Objet :"
        },
        "project": {
          "title": "Projet :"
        },
        "zone": {
          "title": "Dans la zone :"
        },
        "report": {
          "title": "Compte rendu lié",
          "at": "du :",
          "by": "par :",
          "indicators": "Indicateurs"
        },
        "milestones": {
          "title": "Jalons",
          "endDate": "Prévu",
          "completionDate": "Réel"
        },
        "timeRecording": {
          "title": "Suivi de l’activité :"
        }
      }
    },
    "listsPage": {
      "title": "Listes",
      "toggle": {
        "wbs": "Liste",
        "statuses": "Statut"
      },
      "filters": {
        "dataType": {
          "list": "Listes",
          "task": "Tâches",
          "milestone": "Jalons",
          "event": "Évènements",
          "completedWork": "Travail réalisé",
          "startedElement": "Tâches commencées",
          "notStartedElement": "Tâches non commencées",
          "seeDataType": "Montrer :",
          "allDataType": "Tout"
        },
        "show": "Montrer",
        "seeTasksOf": "Voir les tâches de",
        "resetFilters": "Réinitialiser",
        "me": " (Moi)",
        "resourcesFilterTitle": "Ressources",
        "groupsFilterTitle": "Groupes",
        "tagsFilterTitle": "Tags ressources",
        "allResources": "Tout le monde",
        "sorter": {
          "title": "Trier par :",
          "default": "Aucun tri (par défault)",
          "startingDate": "Date de début",
          "endDate": "Date butoir",
          "completionDate": "Date de réalisation",
          "creationDate": "Date de création"
        }
      },
      "sorts": {
        "title": "Trier par :",
        "ascendingRank": "Aucun tri",
        "ascendingName": "A > Z",
        "descendingName": "Z > A",
        "ascendingStartDate": "Date de début",
        "ascendingEndDate": "Date butoir",
        "ascendingCompletionDate": "Date de réalisation",
        "zone": "Zones"
      },
      "export": "Exporter",
      "completionDate": "réel",
      "statuses": {
        "emptyList": "Aucune tâche"
      }
    },
    "documentsPage": {
      "title": "Documents",
      "reportsPage": {
        "filters": {
          "show": "Montrer",
          "author": "Filtrer par",
          "date": "Trier par",
          "resetFilter": "Réinitialiser les filtres",
          "newestReportsFilter": "Le plus récent",
          "oldestReportsFilter": "Le plus ancien",
          "all": "Tout"
        },
        "header": {
          "name": "Libellé",
          "submissionDate": "Date de soumission",
          "author": "Rapporteur",
          "indicators": "Indicateurs"
        },
        "remove": "Supprimer",
        "duplicate": "Dupliquer",
        "export": "Exporter"
      },
      "documentsPage": {
        "header": {
          "name": "Nom",
          "createdBy": "Créateur",
          "creationDate": "Date de création"
        },
        "elementCreationMenu": {
          "button": "Ajouter",
          "uploadDocument": "Fichier",
          "createFolder": "Dossier",
          "createDocx": "Docx",
          "createSlide": "Slide",
          "createPdf": "Pdf",
          "createExcel": "Excel"
        },
        "placeholder": {
          "title": "Votre espace de gestion documentaire est vide",
          "addElement": "Voulez-vous ajouter un élément ?"
        },
        "download": "Télécharger",
        "rename": "Renommer",
        "remove": "Supprimer",
        "move": "Déplacer",
        "edit": "Modifier",
        "addToTemplates": "Créer modèle"
      },
      "sideBar": {
        "reports": "Comptes rendus",
        "folder": "Fichiers"
      }
    },
    "ganttPage": {
      "title": "Gantt",
      "viewSelection": {
        "daily": "Vue journalière",
        "weekly": "Vue journalière",
        "monthly": "Vue mensuelle",
        "yearly": "Vue annuelle"
      },
      "displayOverdueTasks": "Tâches en retard",
      "week": "S",
      "projectEdition": {
        "title": "Affichage du gantt",
        "message": "Pour afficher la vue Gantt, veuillez indiquer une date de début et de fin à votre projet.",
        "define": "Définir",
        "startDate": "comme date de début",
        "endDate": "comme date de fin",
        "confirm": "Valider"
      },
      "sorts": {
        "default": "Aucun tri",
        "ascendingAlphabeticalOrder": "A > Z",
        "descendingAlphabeticalOrder": "Z > A",
        "startDate": "Date de début",
        "endDate": "Date butoir",
        "completionDate": "Date de réalisation"
      },
      "filters": {
        "dataType": {
          "list": "Listes",
          "task": "Tâches",
          "milestone": "Jalons",
          "doneElement": "Travail réalisé",
          "startedElement": "Tâches commencées",
          "notStartedElement": "Tâches non commencées",
          "show": "Montrer",
          "event": "Évènements",
          "startElement": "Tâches commencées",
          "notStartElement": "Tâches non commencées",
          "allDataType": "Tout"
        },
        "seeTasksOf": "Filtrer par",
        "zonesPlaceholder": "Toutes les zones",
        "zonePlaceholder": "Tous les projets",
        "resourcePlaceholder": "Tout le monde",
        "resetFilter": "Réinitialiser",
        "placeholder": "Tout le monde",
        "sorter": {
          "title": "Trier par :",
          "default": "Aucun tri (par défault)",
          "startingDate": "Date de début",
          "endDate": "Date butoir",
          "completionDate": "Date de réalisation",
          "creationDate": "Date de création"
        }
      },
      "moveToToday": "Aller à aujourd'hui",
      "allocations": {
        "title": "Ressources affectées",
        "estimatedHours": "Estimé",
        "allocatedHours": "Alloué",
        "completion": "% Réalisé"
      }
    },
    "externalLinksList": {
      "edit": "Modifier le lien",
      "remove": "Supprimer le lien"
    },
    "discussionsPage": {
      "title": "Discussions",
      "add": "Discussion",
      "comments": "commentaire(s)",
      "remove": "supprimer"
    }
  },
  "projectModelsPage": {
    "add": "Modèle",
    "edit": "Modifier",
    "use": "Créer un projet"
  },
  "moveElement": {
    "title": "Déplacer l'élément",
    "submit": "Déplacer",
    "cancel": "Annuler",
    "project": "Dans le projet",
    "list": "Dans la liste",
    "conserveTime": {
      "list": "Aligner la date de début de la liste avec celle de la nouvelle liste",
      "task": "Aligner la date de début de la tâche avec celle de la nouvelle liste",
      "event": "Aligner la date de début de l'événement avec celle de la nouvelle liste",
      "milestone": "Aligner la date du jalon avec celle de la nouvelle liste"
    }
  },
  "editResource": {
    "title": "Fiche ressource",
    "name": "Nom de la ressource",
    "namePlaceholder": "Nom de la ressource",
    "inputProfession": "Fonction dans l'organisation",
    "inputRole": "Rôle",
    "inputDescription": "Description (optionnel)",
    "tagsTitle": "Tags ressource",
    "save": "Enregistrer",
    "affiliation": "Cette ressource est externe",
    "cancel": "Annuler",
    "professionPlaceholder": "Fonction dans l'organisation",
    "descriptionPlaceholder": "Description",
    "addCostProfile": "Ajouter un profil",
    "search": "Rechercher",
    "projects": "Projets",
    "allocationTitle": "Gère la validation des temps de",
    "calendarHolidaysTitle": "Calendrier de jours féries",
    "inputCalendarHolidays": "Choisir un calendrier de jours fériés",
    "capacity": "Capacité",
    "addButton": "Ajouter",
    "default": "Aucun",
    "secondaryCriteria": "Champs personnalisés"
  },
  "activateResource": {
    "title": "Activer une ressource ",
    "warning": "Vous êtes sur le point d'Activer une ressource .",
    "save": "Enregistrer",
    "cancel": "Annuler"
  },
  "disableResource": {
    "title": "Désactiver une ressource ",
    "warning": "Vous êtes sur le point de Désactiver une ressource.",
    "save": "Enregistrer",
    "cancel": "Annuler"
  },
  "editProjectResource": {
    "title": "Modifier une ressource projet",
    "inputProfession": "Fonction dans le projet",
    "inputRole": "Rôle",
    "inputDescription": "Description (optionnel)",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "professionPlaceholder": "Fonction dans le projet",
    "descriptionPlaceholder": "Description"
  },
  "disableProjectResource": {
    "title": "Désactiver une ressource projet",
    "warning": "Vous êtes sur le point de Désactiver un membre de l'équipe.",
    "save": "Enregistrer",
    "cancel": "Annuler"
  },
  "activateProjectResource": {
    "title": "Activer une ressource projet",
    "warning": "Vous êtes sur le point d'Activer un membre de l'équipe.",
    "save": "Enregistrer",
    "cancel": "Annuler"
  },
  "secondaryCriteriaTemplate": {
    "title": "Champs personnalisés locaux",
    "add": "Ajouter",
    "remove": "Supprimer",
    "views": {
      "title": "Élements concernés",
      "project": "Projets",
      "resource": "Ressources",
      "projectElement": "Élements de projets",
      "projectReport": "Comptes rendus",
      "timeRecord": "Saisie de temps"
    },
    "form": {
      "type": {
        "label": "Type",
        "placeholder": "Typer votre critère",
        "types": {
          "number": "Nombre",
          "text": "Texte",
          "richText": "Texte riche",
          "date": "Date",
          "list": "Liste",
          "document": "Image",
          "link": "Lien",
          "resource": "Ressource"
        }
      },
      "name": {
        "label": "Nom",
        "placeholder": "Nommer votre critère",
        "translations": "Traductions",
        "defaultName": "Sans nom"
      },
      "accessRoles": {
        "label": "Permissions",
        "read": "Qui peut voir la donnée",
        "write": "Qui peut modifier la donnée"
      },
      "options": {
        "label": "Options",
        "multiple": "Sélection multiple",
        "required": "Requis",
        "add": "Ajouter"
      },
      "reset": "Réinitialiser",
      "submit": "Modifier",
      "cancel": "Annuler"
    }
  },
  "editSecondaryCriteriaTemplate": {
    "title": "Supprimer votre critère secondaire",
    "message": "Attention, vous êtes sur le point de supprimer un critère secondaire. La suppression de votre critère secondaire est définitive et entraînera la suppression de toutes les données associées. Êtes-vous sûr de vouloir continuer ?",
    "cancel": "Annuler",
    "confirm": "Supprimer"
  },
  "utilityPage": {
    "title": "Personnalisation",
    "navigation": {
      "projects": "Statuts de projet",
      "projectReportTemplate": "Modèle de compte rendu",
      "projectModels": "Modèles de projet",
      "secondaryCriteriaTemplate": "Champs personnalisés"
    },
    "projectPage": {
      "projectStatuses": {
        "title": "Gestion des statuts du projet",
        "subTitle": "Ajoutez ou supprimez des statuts de projet.",
        "placeholder": "Nommer un statut",
        "errorName": "Le nom ne doit pas dépasser 256 caractères"
      }
    },
    "projectReportTemplatePage": {
      "indicators": "Indicateurs déclaratifs",
      "fields": "Champs",
      "addField": "Ajouter un champ",
      "emptyFieldsDropzone": "Glissez un champ ou un critère ici, ou ajoutez un champ ci-dessous",
      "indicatorsForm": {
        "placeholder": "Nom de l'indicateur"
      },
      "textFieldsForm": {
        "placeholder": "Ex : Prochaine étape"
      },
      "save": "Enregistrer le modèle",
      "criteria": "Champs personnalisés",
      "addTemplate": "Ajouter un modèle",
      "removeTemplate": "Supprimer le modèle",
      "templateName": "Nom du modèle",
      "templateNamePlaceholder": "Saisir le nom du modèle"
    }
  },
  "calendarPage": {
    "monthlyView": "Mois",
    "weeklyView": "Semaine",
    "dailyView": "Jour",
    "showMoreEvents": "Plus",
    "showLessEvents": "Moins",
    "to": "à",
    "sideBar": {
      "title": "Vos calendriers",
      "elementTypeFilter": {
        "label": "Afficher",
        "task": "Tâches",
        "milestone": "Jalons",
        "event": "Événements",
        "unavailability": "Indisponibilités"
      }
    },
    "filters": {
      "title": "Filtrer par : ",
      "zoneDefault": "Toutes les zones",
      "resourceDefault": "Tout le monde",
      "dataType": {
        "placeholder": "Types d'éléments",
        "task": "Tâches",
        "milestone": "Jalons",
        "event": "Événements",
        "unavailability": "Indisponibilités"
      }
    },
    "exports": {
      "export": "Exporter le calendrier"
    }
  },
  "exportReportsPage": {
    "title": "Rapports / Exports",
    "subTitle": "Créer un rapport",
    "description": "Sélectionnez les options souhaitées pour créer le rapport",
    "reportType": {
      "title": "Sélectionnez le type de rapport",
      "subTitle": "Sélectionnez l'une des options ci-dessous"
    },
    "resourceProjectAllocationReport": {
      "title": "Synthèse Mensuelle du Temps de Travail",
      "name": "Rapport Mensuel de Gestion du Temps",
      "subTitle": "Suivi détaillé du temps alloué et réparti sur chaque mois, permettant une meilleure gestion et optimisation des ressources horaires.",
      "startDate": "Début"
    },
    "resourceReport": {
      "name": "Rapport des ressources de la planzone",
      "title": "Ressources planzone",
      "subTitle": "Liste de toutes les ressources de la planzone et leurs attributs",
      "projectName": "Rapport des membres du projet ",
      "projectTitle": "Membres du projet",
      "projectSubTitle": "Liste des membres du projet et leurs attributs"
    },
    "dailyPlanningReport": {
      "name": "Planning horaire du projet",
      "title": "Planning horaire du projet",
      "subTitle": "Planning des éléments du projet avec une granularité heure / jour.",
      "startDate": "Début",
      "endDate": "Fin",
      "elementTypes": "Types d'éléments :",
      "columns": "Afficher :"
    },
    "resourceAllocatedTimeReport": {
      "name": "Rapport des temps alloués des ressources de",
      "title": "Temps alloués des ressources",
      "subTitle": "Temps alloué à chaque ressource par jour, déduit de son calendrier hebdomadaire et de sa capacité restante",
      "startDate": "Début",
      "endDate": "Fin"
    },
    "biExportReport": {
      "title": "Export BI",
      "subTitle": "Génère les fichiers CSV (projets, tâches, ressources, allocations, timesheets, dépenses, profils de coût) de la période et les dépose dans les documents de la planzone",
      "startDate": "Début",
      "endDate": "Fin",
      "launch": "Lancer l'export",
      "invalidRange": "La date de début doit être antérieure ou égale à la date de fin",
      "openDocuments": "Ouvrir les documents",
      "status": {
        "PENDING": "En attente",
        "RUNNING": "En cours",
        "COMPLETED": "Terminé",
        "PARTIAL": "Terminé partiellement",
        "FAILED": "Échoué"
      }
    },
    "wbsZonesReport": {
      "name": "rapport globale de la planzone ",
      "title": "Tâches  de projet",
      "subTitle": "Une liste des zones de Planzone, incluant leurs projets et les listes de tâches associées ",
      "download": "Télécharger",
      "filters": {
        "title": "Filtrer par : ",
        "zoneDefault": "Toutes les zones",
        "resourceDefault": "Tout le monde",
        "dataType": {
          "list": "Listes",
          "task": "Tâches",
          "milestone": "Jalons",
          "event": "Évènements",
          "doneElement": "Travail réalisé",
          "startedElement": "Tâches commencées",
          "notStartedElement": "Tâches non commencées",
          "seeDataType": "Montrer :",
          "allDataType": "Tout"
        },
        "show": "Montrer",
        "seeTasksOf": "Voir les tâches de",
        "resetFilters": "Réinitialiser",
        "me": " (Moi)",
        "resourcesFilterTitle": "Ressources",
        "groupsFilterTitle": "Groupes",
        "tagsFilterTitle": "Tags ressources",
        "allResources": "Tout le monde"
      },
      "sorts": {
        "title": "Trier par :",
        "default": "Aucun tri",
        "ascendingAlphabeticalOrder": "A > Z",
        "descendingAlphabeticalOrder": "Z > A",
        "startDate": "Date de début",
        "endDate": "Date butoir",
        "completionDate": "Date de réalisation"
      }
    },
    "timeSheetReport": {
      "name": "Rapport de feuille de temps de",
      "title": "Feuille de temps globale par projet",
      "subTitle": "Ensemble des temps passés par les ressources de la Planzone sur une période de temps donnée par projet",
      "startDate": "Début",
      "endDate": "Fin",
      "download": "Télécharger",
      "exportLabel": "Exporter :",
      "integrationDateFilterAll": "Tous",
      "filterByResourceIntegrationDate": "Jusqu'à la date d'intégration de la ressource",
      "filterByProjectIntegrationDate": "Jusqu'à la date d'intégration du projet",
      "views": {
        "monthly": "Vue mensuelle",
        "weekly": "Vue hebdomadaire",
        "daily": "Vue journalière"
      }
    },
    "timeSheetByTaskReport": {
      "name": "feuille de temps globale de ",
      "title": "Feuille de temps globale par tache",
      "subTitle": "Ensemble des temps passés par les ressources de la Planzone sur une période de temps donnée par tâche",
      "startDate": "Début",
      "endDate": "Fin",
      "download": "Télécharger",
      "exportLabel": "Exporter :",
      "integrationDateFilterAll": "Tous",
      "filterByResourceIntegrationDate": "Jusqu'à la date d'intégration de la ressource",
      "filterByProjectIntegrationDate": "Jusqu'à la date d'intégration du projet",
      "views": {
        "monthly": "Vue mensuelle",
        "weekly": "Vue hebdomadaire",
        "daily": "Vue journalière"
      }
    },
    "customCpamReport": {
      "title": "Rapport CPAM",
      "name": "Rapport CPAM ",
      "year": "Année",
      "projects": "Zone / Projet(s)",
      "filterDefault": "Toutes les zones",
      "resetFilters": "Réinitialiser"
    },
    "taskBudgetReport": {
      "name": "Suivi du temps alloué et passé par projet de ",
      "title": "Suivi du temps alloué et passé par projet",
      "subTitle": "Pour chaque tâche de vos projets : temps alloué, temps passé (toutes ressources confondues) et temps restant. Un onglet par projet.",
      "stopDate": "Date d'arrêt",
      "filters": {
        "title": "Filtrer par : ",
        "projectDefault": "Tous les projets",
        "resetFilters": "Réinitialiser"
      }
    },
    "download": "Télécharger"
  },
  "inviteMembers": {
    "title": "Inviter de nouveaux collaborateurs",
    "message": "Entrez une ou plusieurs adresse(s) email des personnes que vous souhaitez inviter à rejoindre votre équipe projet. Vous pouvez leur envoyer un message personnalisé dans la section ci-dessous.",
    "emailTitle": "Email (requis)",
    "lastNameTitle": "Nom complet (requis)",
    "firstNameTitle": "Nom complet (requis)",
    "roleTitle": "Rôle",
    "messageTitle": "Message",
    "emailPlaceholder": "Email",
    "lastNamePlaceholder": "Nom",
    "firstNamePlaceholder": "Prénom",
    "languagePlaceholder": "Langue",
    "rolePlaceholder": "Rôle",
    "messagePlaceholder": "Je souhaite que vous rejoigniez la Planzone « {{planzone}} ».",
    "duplicatedInvitation": "Ce membre a déjà été invité.",
    "invalidEmail": "Vous devez entrer une adresse e-mail valide.",
    "invalidLastName": "Vous devez entrer un nom.",
    "invalidFirstName": "Vous devez entrer un prénom.",
    "emptyRole": "Vous devez entrer un role.",
    "addMember": "Ajouter une personne",
    "cancel": "Annuler",
    "confirm": "Envoyer"
  },
  "documentUpload": {
    "title": "Importer des fichiers",
    "message": "Glissez et déposez vos documents ici",
    "placeholder": "Sélectionner des documents"
  },
  "listCreation": {
    "submit": "Créer",
    "cancel": "Annuler",
    "title": "Créer une liste de tâches",
    "nameTitle": "Nommer la liste",
    "namePlaceholder": "Donnez un nom à la liste",
    "descriptionTitle": "Description",
    "descriptionPlaceholder": "",
    "startDateTitle": "Début",
    "startDatePlaceholder": "Choisir une date",
    "endDateTitle": "Fin",
    "endDatePlaceholder": "Choisir une date",
    "parentListTitle": "Fait partie de",
    "parentListPlaceholder": "Choisir une liste"
  },
  "projectPortfolioCreation": {
    "title": "Créer un portefeuille de projet",
    "nameTitle": "Nommer le portefeuille",
    "namePlaceholder": "Nommer le portefeuille",
    "projectSelectionTitle": "Sélectionner des projets",
    "projectSelectionPlaceholder": "Sélectionner un ou plusieurs projets",
    "descriptionTitle": "Description (optionnel)",
    "descriptionPlaceholder": "",
    "submit": "Créer",
    "cancel": "Annuler"
  },
  "projectPortfolioEdition": {
    "title": "Modifier un portefeuille de projet",
    "nameTitle": "Nommer le portefeuille",
    "namePlaceholder": "Nommer le portefeuille",
    "projectSelectionTitle": "Sélectionner des projets",
    "projectSelectionPlaceholder": "Sélectionner un ou plusieurs projets",
    "descriptionTitle": "Description (optionnel)",
    "descriptionPlaceholder": "",
    "submit": "Enregistrer",
    "cancel": "Annuler"
  },
  "milestoneCreation": {
    "submit": "Créer",
    "cancel": "Annuler",
    "title": "Créer un jalon",
    "nameTitle": "Nommer le jalon",
    "namePlaceholder": "Donnez un nom au jalon",
    "descriptionTitle": "Description",
    "descriptionPlaceholder": "",
    "endDateTitle": "Fin",
    "endDatePlaceholder": "Choisir une date",
    "parentListTitle": "Fait partie de",
    "parentListPlaceholder": "Choisir une liste",
    "projectSelectionPlaceholder": "Sélectionnez un projet",
    "inProject": "Dans le projet"
  },
  "accessRestrictionsEdition": {
    "personalSynthesis": "Mon espace > Ma synthèse",
    "personalTimesheet": "Mon espace > Suivi temporel",
    "resources": "Gestion > Ressources",
    "costProfiles": "Gestion > Profils",
    "projectTemplates": "Personnalisation > Modèle de projet",
    "projectReportsTemplate": "Personnalisation > Modèle de Compte Rendu",
    "projectStatuses": "Personnalisation > Statuts de projet",
    "secondaryCriteriaTemplate": "Personnalisation > Champs personnalisés",
    "strategicAxes": "Personnalisation > Axes stratégiques",
    "portfolios": "Portefeuille",
    "calendar": "Calendrier",
    "documents": "Documents",
    "exports": "Rapports / exports",
    "onlyOffice": "Création/édition de document",
    "capacity": "Gestion > Capacité",
    "workload": "Gestion > Charges",
    "occupancy": "Gestion > Taux d'occupation"
  },
  "portfolioAssignation": {
    "search": "Rechercher",
    "add": "+ Ajouter un portefeuille",
    "name": "Nommer le portefeuille"
  },
  "listEdition": {
    "submit": "Envoyer",
    "cancel": "Annuler",
    "nameTitle": "Nommer la liste",
    "namePlaceholder": "Donnez un nom à la liste",
    "descriptionTitle": "Description",
    "descriptionPlaceholder": "",
    "startDateTitle": "Début",
    "startDatePlaceholder": "Choisir une date",
    "endDateTitle": "Fin",
    "endDatePlaceholder": "Choisir une date",
    "parentListTitle": "Fait partie de",
    "parentListPlaceholder": "Choisir une liste"
  },
  "createStatus": {
    "addStatus": "+ Ajouter un statut",
    "namePlaceholder": "Nommer le statut",
    "noStatus": "Aucun statut"
  },
  "addResourceGroup": {
    "title": "Créer un nouveau groupe de ressources",
    "cancel": "Annuler",
    "create": "Créer",
    "form": {
      "title": "Nom du groupe",
      "namePlaceholder": "Nommer le groupe",
      "titleDescription": "Description",
      "titleResources": "Membres du groupe"
    },
    "sideBarName": "Groupes projet"
  },
  "filterProjectResource": {
    "sideBarName": "Ressources"
  },
  "editResourceGroup": {
    "title": "Modifier le groupe",
    "cancel": "Annuler",
    "create": "Enregistrer",
    "resourcesList": {
      "title": "Membres du groupe",
      "placeholder": "Sélectionnez une ressource",
      "addResource": "+ Ajouter une personne",
      "permission": "Permissions",
      "function": "Fonction"
    },
    "form": {
      "title": "Nommer le groupe",
      "namePlaceholder": "Nom",
      "description": "Description"
    }
  },
  "projectBudgetSynthesis": {
    "title": "Budget",
    "plannedBudget": {
      "title": "Planifié",
      "headers": {
        "planned": "Planifié",
        "dateMonitoring": "Suivi à date",
        "total": "Total",
        "workload": "Travail"
      },
      "real": "Réel",
      "acquired": "Acquis",
      "planned": "Planifié",
      "budgetAllocated": "Budget alloué",
      "allocated": "Alloué",
      "past": "Passé",
      "remaining": "Reste à faire"
    },
    "monitoring": {
      "title": "Suivi",
      "trackingPlannedValueOfProject": "Valeur Planifiée",
      "trackingAcquiredValue": "Valeur Acquise",
      "trackingRealCost": "Coût Réel",
      "percentOfBudgetConsumption": "Conso. budget",
      "percentOfAcquiredValue": "Valeur acquise"
    },
    "workload": {
      "title": "Travail"
    },
    "expensesBreakdownByExpenseType": {
      "title": "Répartition des coûts par type de dépenses"
    },
    "costsBreakdownByResourceType": {
      "title": "Répartition des couts par type de ressources",
      "costs": "Coûts",
      "external": "Externes",
      "internal": "Internes",
      "material": "Matérielles"
    },
    "expenses": {
      "title": "Liste des dépenses",
      "create": "Dépense",
      "orderNumber": "N° Bon commande",
      "name": "Libellé",
      "expenseType": "Type",
      "quantity": "Qté",
      "unitAmount": "Montant U.",
      "totalAmount": "Montant total",
      "plannedDate": "Planifié",
      "actualDate": "Réel",
      "attachments": "Pièce(s) jointe(s)",
      "attachmentsAdd": "Ajouter",
      "creation": {
        "title": "Ajouter une dépense au projet",
        "confirm": "Enregistrer",
        "cancel": "Annuler",
        "quantity": "Quantité",
        "unitAmount": "Montant",
        "expenseType": "Type de coût",
        "newExpenseType": "Nouveau type de coût",
        "createExpenseType": "Créer"
      },
      "removal": {
        "button": "Supprimer",
        "title": "Êtes-vous sûr de vouloir supprimer cette dépense ?",
        "confirmation": "La dépense sera supprimée et retirée du budget du projet.",
        "cancel": "Annuler",
        "confirm": "Supprimer"
      },
      "edition": {
        "button": "Modifier",
        "title": "Éditer une dépense du projet",
        "confirm": "Enregistrer",
        "cancel": "Annuler",
        "quantity": "Quantité",
        "unitAmount": "Montant",
        "expenseType": "Type de coût",
        "newExpenseType": "Nouveau type de coût",
        "createExpenseType": "Créer"
      }
    }
  },
  "addIdentityProvider": {
    "title": "SSO",
    "cas": {
      "loginUrl": {
        "label": "Login URL",
        "placeholder": "Login URL"
      },
      "protocol": {
        "label": "Protocol",
        "placeholder": "Protocol"
      },
      "clientName": {
        "label": "Client name",
        "placeholder": "Client name"
      },
      "enabled": "Activé"
    },
    "azure": {
      "clientId": {
        "label": "Client ID",
        "placeholder": "Client ID"
      },
      "clientSecret": {
        "label": "Client secret",
        "placeholder": "Client secret"
      },
      "tenant": {
        "label": "Tenant",
        "placeholder": "Tenant"
      },
      "discoveryUri": {
        "label": "Discovery URI",
        "placeholder": "Discovery URI"
      },
      "scope": {
        "label": "Scope",
        "placeholder": "Scope"
      },
      "callbackUrlType": {
        "label": "Callback url type",
        "placeholder": "Callback url type"
      },
      "loginUrl": {
        "label": "Login URL",
        "placeholder": "Login URL"
      },
      "clientName": {
        "label": "Client name",
        "placeholder": "Client name"
      },
      "displayName": {
        "label": "Display name",
        "placeholder": "Display name"
      },
      "principalAttributeId": {
        "label": "Principal attribute id",
        "placeholder": "Principal attribute id"
      },
      "enabled": "Activé"
    },
    "submit": "Envoyer"
  },
  "removeResourceGroup": {
    "title": "Êtes-vous sûr de vouloir supprimer ce groupe de ressources ?",
    "group": "Le groupe",
    "removal": "sera supprimé définitivement",
    "confirm": "Supprimer",
    "cancel": "Annuler"
  },
  "removeTask": {
    "title": "Êtes-vous sûr de vouloir supprimer cette tâche ?",
    "warning": "La tâche sera supprimée définitivement :",
    "group": "La tâche",
    "removal": "sera supprimée définitivement",
    "confirm": "Supprimer",
    "cancel": "Annuler"
  },
  "removeProjectPortfolio": {
    "title": "Êtes-vous sûr de vouloir supprimer ce portefeuille de projet ?",
    "group": "Le portefeuille",
    "removal": "sera supprimé de votre Planzone. Les projets resteront cependant conservés.",
    "confirm": "Supprimer",
    "cancel": "Annuler"
  },
  "removeIdentityProvider": {
    "title": "Êtes-vous sûr de vouloir supprimer ce SSO ?",
    "message": "Le SSO sera supprimé définitivement.",
    "confirm": "Supprimer",
    "cancel": "Annuler"
  },
  "removeProjectFromPortfolio": {
    "title": "Êtes-vous sûr de vouloir retirer ce projet du portefeuille ?",
    "confirmation": "Le projet <strong>{{- project}}</strong> sera retiré du portefeuille <strong>{{- portfolio}}</strong>.",
    "confirm": "Supprimer",
    "cancel": "Annuler"
  },
  "removeEvent": {
    "title": "Êtes-vous sûr de vouloir supprimer cet événement ?",
    "group": "L'événement",
    "removal": "sera supprimé définitivement",
    "confirm": "Supprimer",
    "cancel": "Annuler"
  },
  "removeCostProfile": {
    "title": "Suppression du profil de coût",
    "message": "Êtes-vous sûr de vouloir supprimer le profil de coût « {{- name}} » ?",
    "hour": "heure",
    "confirm": "Supprimer",
    "cancel": "Annuler"
  },
  "removeCost": {
    "title": "Suppression de coût",
    "message": "Êtes-vous sûr de vouloir supprimer ce coût ?",
    "confirm": "Supprimer",
    "cancel": "Annuler"
  },
  "removeFolder": {
    "title": "Supprimer un dossier",
    "message": "Êtes-vous sûr de supprimer le dossier « {{folderName}} » ?",
    "warning": "Ce dossier et tous ses documents seront définitivement supprimés.",
    "confirm": "Supprimer",
    "cancel": "Annuler"
  },
  "removeDocument": {
    "title": "Supprimer un document",
    "message": "Êtes-vous sûr de supprimer le document « {{documentName}} » ?",
    "confirm": "Supprimer",
    "cancel": "Annuler"
  },
  "removeProjectReport": {
    "title": "Êtes-vous sûr de vouloir supprimer ce rapport ?",
    "group": "Le rapport",
    "removal": "sera supprimé définitivement",
    "confirm": "Supprimer",
    "cancel": "Annuler"
  },
  "removeMilestone": {
    "title": "Êtes-vous sûr de vouloir supprimer ce jalon ?",
    "group": "Le jalon",
    "removal": "sera supprimé définitivement",
    "confirm": "Supprimer",
    "cancel": "Annuler"
  },
  "removeProject": {
    "title": "Êtes-vous sûr de vouloir supprimer ce projet ?",
    "projectModelTitle": "Êtes-vous sûr de vouloir supprimer ce modèle de projet ?",
    "group": "Ce projet et ses",
    "projectModelGroup": "Ce modèle de projet et ses",
    "singleGroup": "Ce projet dont",
    "projectModelGroupSingleGroup": "Ce modèle de projet dont",
    "one": "un",
    "elements": "éléments",
    "element": "élément",
    "noElements": "Ce projet sera supprimé définitivement",
    "projectModelNoElements": "Ce modèle de projet sera supprimé définitivement",
    "removal": "seront supprimés définitivement",
    "removeOneElement": "Ce projet va-t-être supprimé.",
    "projectModelRemoveOneElement": "Ce modèle de projet va-t-être supprimé.",
    "confirm": "Supprimer",
    "cancel": "Annuler"
  },
  "removeList": {
    "title": "Êtes-vous sûr de vouloir supprimer cette liste ?",
    "singular": "Cet élément sera supprimé",
    "plural": "Cet élément et ses sous éléments seront supprimés",
    "confirm": "Supprimer",
    "cancel": "Annuler"
  },
  "accountPage": {
    "title": "Mon Compte"
  },
  "projectPortfoliosPage": {
    "title": "Portefeuilles",
    "average": "moy",
    "labels": {
      "projectName": "Nom du projet",
      "dates": "Dates",
      "startDate": "Début",
      "endDate": "Fin",
      "status": "Statut",
      "avgScore": "Score strat.",
      "score": "Score strat.",
      "weather": "Météo",
      "activityMonitoring": {
        "title": "Suivi de l'activité",
        "done": "Réalisé",
        "delayed": "Retard",
        "opened": "Ouvert"
      },
      "workload": {
        "title": "Travail",
        "allocatedTime": "Alloué",
        "spentTime": "Passé",
        "remainingWork": "Restant",
        "remainingWorkShort": "Restant"
      },
      "budget": {
        "title": "Budget",
        "plannedBudget": "Planifié",
        "realCosts": "Réel",
        "acquiredValue": "Acquis"
      }
    },
    "contextualMenu": {
      "projectDetails": "Détails du projet",
      "projectStatus": "Gérer les statuts",
      "createProjectModel": "Créer un modèle",
      "strategicImpact": "Impact stratégique",
      "move": "Déplacer",
      "remove": "Supprimer"
    },
    "filterPlaceholder": "Tous les projets",
    "createProjectPortfolio": "Portefeuille",
    "editProjectPortfolio": "Éditer",
    "removeProjectPortfolio": "Supprimer"
  },
  "statusCreationForm": {
    "namePlaceholder": "Nom du statut*",
    "label": "Inclure un % de complétion",
    "warning": "*Veuillez saisir une valeur entre 0 et 99%",
    "addStatus": "Nouveau statut",
    "submit": "Créer"
  },
  "taskPage": {
    "title": "Détails de la tâche",
    "allocations": {
      "placeholder": "Il n'y a aucune ressource allouée sur cette tâche."
    }
  },
  "milestonePage": {
    "title": "Détails du jalon"
  },
  "listPage": {
    "title": "Détails de la liste"
  },
  "wbs": {
    "columnNames": {
      "statuses": "Statuts",
      "tags": "Tags",
      "allocations": "Assigné à",
      "allocated": "Alloué",
      "spent": "Passé",
      "startDate": "Début",
      "endDate": "Fin",
      "completionDate": "Réel"
    }
  },
  "projectSection": {
    "projectName": "Nom du projet",
    "startDate": "Début",
    "endDate": "Fin",
    "columnNames": {
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "status": "Statut",
      "weather": "Météo",
      "strategicScore": "Score strat.",
      "activityMonitoring": "Suivi de l'activité",
      "activityMonitoring_done": "Réalisé",
      "activityMonitoring_delayed": "Retard",
      "activityMonitoring_opened": "Ouvert",
      "workload": "Travail",
      "workload_allocatedTime": "Alloué",
      "workload_spentTime": "Passé",
      "workload_remainingWork": "Restant",
      "budget": "Budget",
      "budget_plannedBudget": "Planifié",
      "budget_realCosts": "Réel",
      "budget_acquiredValue": "Acquis",
      "budget_allocatedBudget": "alloué",
      "budget_plannedMargin": "Marge planifiée",
      "budget_realMargin": "Marge réelle",
      "projectManagers": "Chef(s) de projet",
      "portfolios": "Portefeuilles"
    },
    "contextualMenu": {
      "projectDetails": "Détails du projet",
      "projectStatus": "Gérer les statuts",
      "createProjectModel": "Créer un modèle",
      "strategicImpact": "Impact stratégique",
      "move": "Déplacer",
      "duplicate": "Dupliquer",
      "remove": "Supprimer"
    }
  },
  "projectListingConfiguration": {
    "title": "Configuration des colonnes",
    "name": "Nom du profil de configuration",
    "roles": "Configurer pour",
    "columns": "Afficher",
    "columnNames": {
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "status": "Statut",
      "weather": "Météo",
      "portfolios": "Portefeuilles",
      "strategicScore": "Score strategique",
      "activityMonitoring": "Suivi de l'activité",
      "activityMonitoring_done": "Suivi de l'activité: Travail réalisé",
      "activityMonitoring_delayed": "Suivi de l'activité: Travail en retard",
      "activityMonitoring_opened": "Suivi de l'activité: Travail ouvert",
      "workload": "Travail",
      "workload_allocatedTime": "Travail: Temps alloué",
      "workload_spentTime": "Travail: Temps passé",
      "workload_remainingWork": "Travail: Travail restant",
      "budget": "Budget",
      "budget_plannedBudget": "Budget: Budget planifié",
      "budget_realCosts": "Budget: Coûts réel",
      "budget_acquiredValue": "Budget: Valeur acquise",
      "budget_allocatedBudget": "Budget: alloué",
      "budget_plannedMargin": "Marge planifiée",
      "budget_realMargin": "Marge réelle",
      "projectManagers": "Chef(s) de projet",
      "tags": "Tags",
      "zone": "Zone"
    },
    "addColumn": "Ajouter",
    "addProfile": "Ajouter une configuration",
    "cancel": "Annuler",
    "add": "Ajouter",
    "remove": "Supprimer",
    "edit": "Modifier"
  },
  "resourcesListingConfiguration": {
    "title": "Configuration des colonnes",
    "name": "Nom du profil de configuration",
    "roles": "Configurer pour",
    "columns": "Afficher",
    "columnNames": {
      "tags": "Tags",
      "role": "Rôle",
      "invitationStatus": "Statut d'invitation",
      "subordinates": "Gère les temps de",
      "organizationalUnit": "Unité organisationnelle"
    },
    "addColumn": "Ajouter",
    "addProfile": "Ajouter une configuration",
    "cancel": "Annuler",
    "add": "Ajouter",
    "remove": "Supprimer",
    "edit": "Modifier"
  },
  "projectMembersListingConfiguration": {
    "title": "Configuration des colonnes",
    "name": "Nom du profil de configuration",
    "roles": "Configurer pour",
    "columns": "Afficher",
    "columnNames": {
      "tags": "Tags",
      "role": "Rôle"
    },
    "addColumn": "Ajouter",
    "addProfile": "Ajouter une configuration",
    "cancel": "Annuler",
    "add": "Ajouter",
    "remove": "Supprimer",
    "edit": "Modifier",
    "localCriteria": "local"
  },
  "projectDetailsConfiguration": {
    "title": "Configuration du détail du projet",
    "name": "Nom du profil de configuration",
    "roles": "Configurer pour",
    "columns": "Afficher",
    "columnNames": {
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "status": "Statut",
      "weather": "Météo",
      "strategicScore": "Score strategique",
      "activityMonitoring": "Suivi de l'activité",
      "activityMonitoring_done": "Suivi de l'activité: Travail réalisé",
      "activityMonitoring_delayed": "Suivi de l'activité: Travail en retard",
      "activityMonitoring_opened": "Suivi de l'activité: Travail ouvert",
      "workload": "Travail",
      "workload_allocatedTime": "Travail: Temps alloué",
      "workload_spentTime": "Travail: Temps passé",
      "workload_remainingWork": "Travail: Travail restant",
      "budget": "Budget",
      "budget_plannedBudget": "Budget: Budget planifié",
      "budget_realCosts": "Budget: Coûts réel",
      "budget_acquiredValue": "Budget: Valeur acquise",
      "budget_allocatedBudget": "Budget: alloué",
      "budget_plannedMargin": "Marge planifiée",
      "budget_realMargin": "Marge réelle",
      "projectManagers": "Chef(s) de projet",
      "tags": "Tags",
      "zone": "Zone"
    },
    "addColumn": "Ajouter",
    "addProfile": "Ajouter une configuration",
    "cancel": "Annuler",
    "add": "Ajouter",
    "remove": "Supprimer",
    "edit": "Modifier"
  },
  "wbsConfiguration": {
    "title": "Configuration des colonnes",
    "name": "Nom du profil de configuration",
    "roles": "Configurer pour",
    "columns": "Afficher",
    "columnNames": {
      "statuses": "Statuts",
      "tags": "Tags",
      "allocations": "Allocations",
      "allocated": "Alloué",
      "spent": "Temps passé",
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "completionDate": "Complétion"
    },
    "localCriteria": "local",
    "addColumn": "Ajouter",
    "addProfile": "Ajouter une configuration",
    "cancel": "Annuler",
    "add": "Ajouter",
    "remove": "Supprimer",
    "edit": "Modifier"
  },
  "projectElementDetailsConfiguration": {
    "title": "Configuration des détails",
    "name": "Nom du profil de configuration",
    "roles": "Configurer pour",
    "columns": "Afficher",
    "columnNames": {
      "statuses": "Statuts",
      "tags": "Tags",
      "allocations": "Allocations",
      "endDate": "Date de fin"
    },
    "localCriteria": "local",
    "addColumn": "Ajouter",
    "addProfile": "Ajouter une configuration",
    "cancel": "Annuler",
    "add": "Ajouter",
    "remove": "Supprimer",
    "edit": "Modifier"
  },
  "resourceDetailsConfiguration": {
    "title": "Configuration du détail de la ressource",
    "name": "Nom du profil de configuration",
    "roles": "Configurer pour",
    "columns": "Afficher",
    "addColumn": "Ajouter",
    "addProfile": "Ajouter une configuration",
    "cancel": "Annuler",
    "add": "Ajouter",
    "remove": "Supprimer",
    "edit": "Modifier"
  },
  "constrainElement": {
    "title": {
      "START_START": "Créer une contrainte début début",
      "END_END": "Créer une contrainte fin fin",
      "START_END": "Créer une contrainte début fin",
      "END_START": "Créer une contrainte fin début"
    },
    "dateTypes": {
      "START": "Le début",
      "END": "La fin"
    },
    "beginsAt": "au",
    "endsAt": "à",
    "of": "De",
    "startDate": "Début",
    "endDate": "Fin",
    "cancel": "Annuler",
    "submit": "Créer"
  },
  "editConstraint": {
    "title": {
      "START_START": "Mettre à jour une contrainte début début",
      "END_END": "Mettre à jour une contrainte fin fin",
      "START_END": "Mettre à jour une contrainte début fin",
      "END_START": "Mettre à jour une contrainte fin début"
    },
    "dateTypes": {
      "START": "Le début",
      "END": "La fin"
    },
    "beginsAt": "au",
    "endsAt": "à",
    "of": "De",
    "startDate": "Début",
    "endDate": "Fin",
    "remove": "Supprimer",
    "cancel": "Annuler",
    "submit": "Mettre à jour"
  },
  "constraintTypeForm": {
    "constraintTypes": {
      "EXACTLY": "exactement",
      "AT_MOST": "pas plus tard que",
      "AT_LEAST": "pas plus tôt que"
    },
    "deltas": {
      "days": "jour(s)",
      "hours": "heure(s)",
      "before": "avant",
      "after": "après"
    },
    "begins": "Commence",
    "ends": "Termine"
  },
  "listsList": {
    "placeholder": {
      "emptyMatch": "Aucun élément ne correspond à votre recherche."
    },
    "contextualMenu": {
      "edit": "Éditer",
      "move": "Déplacer",
      "addIn": "Créer dedans",
      "addAfter": "Créer après",
      "duplicate": "Dupliquer",
      "remove": "Supprimer"
    },
    "quickCreation": {
      "createTask": "Nommer une tâche",
      "createList": "Nommer la liste",
      "createMilestone": "Nommer un jalon",
      "createEvent": "Nommer un événement",
      "createUnavailability": "Nommer une indisponibilité",
      "task": "Tâche",
      "list": "Liste",
      "milestone": "Jalon",
      "event": "Évènement",
      "unavailability": "Indisponibilité",
      "submit": "Créer"
    },
    "tags": {
      "placeholder": "Nouveau tag",
      "submit": "Ajouter"
    }
  },
  "materialResourceForm": {
    "nameTitle": "Nommer la ressource",
    "namePlaceholder": "Ressource1..",
    "roleTitle": "Rôle",
    "rolePlaceholder": "Rôle",
    "descriptionTitle": "Description (optionnel)"
  },
  "virtualResourceForm": {
    "nameTitle": "Nommer la ressource",
    "namePlaceholder": "Ressource1..",
    "roleTitle": "Rôle (optionnel)",
    "rolePlaceholder": "Rôle",
    "professionTitle": "Fonction",
    "professionPlaceholder": "Ressource",
    "descriptionTitle": "Description (optionnel)"
  },
  "planzoneMaterialResourceAddition": {
    "title": "Créer une ressource matérielle",
    "confirm": "Créer",
    "cancel": "Annuler"
  },
  "projectMaterialResourceAddition": {
    "title": "Créer une ressource matérielle",
    "confirm": "Créer",
    "cancel": "Annuler"
  },
  "planzoneVirtualResourceAddition": {
    "title": "Créer une ressource virtuelle",
    "addResource": "Ajouter un autre membre virtuel",
    "confirm": "Créer",
    "cancel": "Annuler"
  },
  "projectVirtualResourceAddition": {
    "title": "Créer une ressource virtuelle",
    "addResource": "Ajouter un autre membre virtuel",
    "confirm": "Créer",
    "cancel": "Annuler"
  },
  "removeResourceFromProject": {
    "title": "Retirer un membre du projet",
    "warning": "Vous êtes sur le point de retirer un membre de l'équipe.",
    "transfer": "Transférer d'abord les affectations de cet utilisateur vers quelqu'un d'autre",
    "collaborator": "Sélectionnez un collaborateur",
    "warningTimeRecord": "ATTENTION : La suppression d'un utilisateur entraînera la suppression définitive de toutes ses feuilles de temps effectués dans le cadre de ce projet. Si cet utilisateur a enregistré des heures qui doivent être conservées, veuillez désactiver son accès au lieu de le supprimer.",
    "selectAllTasks": "Sélectionner toutes les tâches",
    "noTasks": "Aucune tâche disponible",
    "cancel": "Annuler",
    "confirm": "Retirer"
  },
  "transferProjectResourceAllocations": {
    "title": "Transférer les allocations",
    "warning": "Transférer les allocations d'une ressource vers une autre dans ce projet.",
    "from": "De la ressource :",
    "to": "Vers la ressource :",
    "selectDestination": "Sélectionner une ressource de destination",
    "selectAllTasks": "Sélectionner toutes les tâches",
    "noTasks": "Aucune tâche allouée à cette ressource",
    "cancel": "Annuler",
    "confirm": "Transférer"
  },
  "kanban": {
    "title": "Kanban",
    "filters": {
      "statuses": {
        "title": "Montrer :",
        "all": "Tout",
        "done": "Travail réalisé",
        "started": "Tâches commencées",
        "planned": "Tâches non commencées"
      },
      "sortFilter": {
        "title": "Trier par :",
        "filterOne": "Aucun tri (par défaut)",
        "filterTwo": "Date de début",
        "filterThree": "Date butoir",
        "filterFour": "Date de réalisation",
        "filterFive": "Date de création",
        "filterSix": "Dernière modification"
      },
      "resourceFilter": {
        "all": "Tout le monde",
        "me": "(moi)",
        "users": "Utilisateurs",
        "groups": "Groupes",
        "tags": "Tags ressources"
      }
    },
    "taskCreation": {
      "addTask": "Nouvelle tâche",
      "namePlaceholder": "Nom",
      "submit": "Créer"
    },
    "task": {
      "startDate": "Début",
      "endDate": "Fin"
    }
  },
  "addMemberFromPlanzone": {
    "location": "Depuis la Planzone"
  },
  "addPlanzoneResourceToProject": {
    "title": "ajouter une ressource depuis la planzone sur le projet",
    "description": "Ajouter des utilisateurs depuis la liste des membres de la planzone",
    "input_one": "Sélectionner une ou plusieurs ressources",
    "removeSelectedResources": "Supprimer tout",
    "clear": "Effacer",
    "input_two": "Sélectionner un rôle",
    "send": "ajouter",
    "cancel": "annuler",
    "placeholder": "Sélectionnez une ressource"
  },
  "addPlanzoneResourceToProjects": {
    "title": "ajouter une ressource depuis la planzone sur plusieurs projets",
    "description": "Ajouter des utilisateurs depuis la liste des membres de la planzone",
    "inputProject": "Sélectionner un ou plusieurs projets",
    "inputRole": "Sélectionner un rôle",
    "submit": "Enregistrer",
    "cancel": "annuler",
    "placeholder": "Sélectionnez des projets"
  },
  "removeResourceFromPlanZone": {
    "title": "suppression d'une ressource de la planzone",
    "description": "Vous êtes sur le point de supprimer une ressource de la Planzone",
    "transfer": "Transférer d'abord les affectations de cet utilisateur vers quelqu'un d'autre.",
    "cancel": "Annuler",
    "confirm": "Supprimer",
    "remove": "Supprimer"
  },
  "unavailabilityRemoval": {
    "title": "Suppression d'une indisponibilité",
    "description": "Vous êtes sur le point de supprimer une indisponibilité",
    "cancel": "Annuler",
    "confirm": "Supprimer",
    "remove": "Supprimer"
  },
  "removeComment": {
    "title": "Supprimer un commentaire",
    "description": "Êtes-vous sûr de vouloir supprimer ce commentaire",
    "cancel": "Annuler",
    "confirm": "Supprimer"
  },
  "comment": {
    "placeholder": "Ajouter un commentaire...",
    "submit": "Envoyer",
    "reply": "Répondre"
  },
  "removeDiscussion": {
    "title": "Supprimer une discussion",
    "description": "Êtes-vous sûr de vouloir supprimer cette discussion",
    "cancel": "Annuler",
    "confirm": "Supprimer"
  },
  "removeTaskStatus": {
    "title": "Suppression d'un statut",
    "warningTasks": "Le statut que vous vous apprêtez à supprimer contient des tâches. Sélectionnez le statut vers lequel transférer celles-ci.",
    "warningNoTasks": "Êtes-vous sûr de vouloir supprimer ce statut de tâche ?",
    "placeholder": "Choisir un statut",
    "cancel": "Annuler",
    "noTasksPlaceholder": "0 tâche(s)",
    "confirmTasks": "Supprimer et transférer les tâches",
    "confirmNoTasks": "Supprimer"
  },
  "projectTaskStatuses": {
    "title": "gérer les statuts de tâches du projet",
    "activeStatus": "statuts actifs",
    "closeStatus": "statuts clos",
    "addStatus": "Nouveau statut"
  },
  "preferences": {
    "profileTitle": "Mon profil",
    "preferencesTitle": "Mes préférences",
    "securityTitle": "Sécurité",
    "notificationsTitle": "Préférences des alertes mail",
    "activityReportTitle": "Fréquence d'envoi de rapport d'activité",
    "calendarTitle": "Calendrier de travail",
    "calendarHolidays": {
      "inputPersonalCalendarHolidays": "Choisir un calendrier de jours fériés",
      "description": "Ce module permet de déterminer les paramétres de disponibilté de vos ressources par défaut"
    },
    "languageSelectionForm": {
      "title": "Langue de la Planzone",
      "languages": ["fr", "en"]
    },
    "profile": {
      "name": "Nom",
      "email": "Adresse email",
      "tags": "Tags ressource"
    },
    "mfa": {
      "title": "Activer l'authentification multifacteur"
    },
    "notifications": {
      "delayedTask": {
        "title": "Une tâche sur laquelle vous êtes affecté(e) est en retard"
      },
      "addedToTask": {
        "title": "Vous avez été affecté(e) sur une tâche"
      },
      "mentionInComment": {
        "title": "Vous avez été mentionné(e) sur un commentaire"
      },
      "replyToComment": {
        "title": "Quelqu'un a répondu à votre commentaire"
      },
      "addedToProject": {
        "title": "Vous avez été affecté(e) sur un projet"
      },
      "projectStatusChanged": {
        "title": "Le statut d'un projet a changé"
      }
    },
    "activityReport": {
      "title": "À quelle fréquence voulez vous recevoir ce rapport ?",
      "explanation": "Le rapport d’activité est un récapitulatif de vos tâches en <span style=\"color:#db5f63;\">retard</span> et <span style=\"color:#4892cc;\">à venir</span>.",
      "sendReport": "Envoyer maintenant",
      "options": {
        "never": "Jamais",
        "everyLastDayOfMonth": "Le dernier jour de chaque mois",
        "everyFifteenthDayOfMonth": "Le 15 de chaque mois",
        "everySecondDayOfMonth": "Le deuxième jour de chaque mois",
        "everyFirstDayOfMonth": "Le premier jour de chaque mois",
        "everySaturday": "Le Samedi",
        "everyFriday": "Le Vendredi",
        "everyThursday": "Le Jeudi",
        "everyWednesday": "Le mercredi",
        "everyTuesday": "Le mardi",
        "everyMonday": "Le lundi",
        "everyTwoDays": "Tous les 2 jours",
        "everyDay": "Tous les jours"
      }
    },
    "changePassword": {
      "title": "Mot de passe",
      "submit": "Enregistrer",
      "currentPassword": "Mot de passe actuel",
      "placeholder": "12 caractères, 1 majuscule et 1 caractère spécial au minimum",
      "errors": {
        "wrongPassword": "La confirmation de votre mot de passe actuel est erronée.",
        "tooShort": "Le mot de passe doit comporter au moins 12 caractères.",
        "specialCharsOrNum": "Le mot de passe doit comporter au moins un chiffre ou un caractère spécial.",
        "upper": "Le mot de passe doit comporter au moins une majuscule.",
        "mismatchedConfirmation": "La confirmation de votre mot de passe ne correspond pas a votre mot de passe."
      }
    },
    "timeZoneForm": {
      "title": "Fuseau Horaire",
      "placeholder": "Sélectionnez un fuseau horaire",
      "timeZones": [
        "Europe/Andorra",
        "Asia/Dubai",
        "Asia/Kabul",
        "Europe/Tirane",
        "Asia/Yerevan",
        "Antarctica/Casey",
        "Antarctica/Davis",
        "Antarctica/DumontDUrville",
        "Antarctica/Mawson",
        "Antarctica/Palmer",
        "Antarctica/Rothera",
        "Antarctica/Syowa",
        "Antarctica/Troll",
        "Antarctica/Vostok",
        "America/Argentina/Buenos_Aires",
        "America/Argentina/Cordoba",
        "America/Argentina/Salta",
        "America/Argentina/Jujuy",
        "America/Argentina/Tucuman",
        "America/Argentina/Catamarca",
        "America/Argentina/La_Rioja",
        "America/Argentina/San_Juan",
        "America/Argentina/Mendoza",
        "America/Argentina/San_Luis",
        "America/Argentina/Rio_Gallegos",
        "America/Argentina/Ushuaia",
        "Pacific/Pago_Pago",
        "Europe/Vienna",
        "Australia/Lord_Howe",
        "Antarctica/Macquarie",
        "Australia/Hobart",
        "Australia/Currie",
        "Australia/Melbourne",
        "Australia/Sydney",
        "Australia/Broken_Hill",
        "Australia/Brisbane",
        "Australia/Lindeman",
        "Australia/Adelaide",
        "Australia/Darwin",
        "Australia/Perth",
        "Australia/Eucla",
        "Asia/Baku",
        "America/Barbados",
        "Asia/Dhaka",
        "Europe/Brussels",
        "Europe/Sofia",
        "Atlantic/Bermuda",
        "Asia/Brunei",
        "America/La_Paz",
        "America/Noronha",
        "America/Belem",
        "America/Fortaleza",
        "America/Recife",
        "America/Araguaina",
        "America/Maceio",
        "America/Bahia",
        "America/Sao_Paulo",
        "America/Campo_Grande",
        "America/Cuiaba",
        "America/Santarem",
        "America/Porto_Velho",
        "America/Boa_Vista",
        "America/Manaus",
        "America/Eirunepe",
        "America/Rio_Branco",
        "America/Nassau",
        "Asia/Thimphu",
        "Europe/Minsk",
        "America/Belize",
        "America/St_Johns",
        "America/Halifax",
        "America/Glace_Bay",
        "America/Moncton",
        "America/Goose_Bay",
        "America/Blanc-Sablon",
        "America/Toronto",
        "America/Nipigon",
        "America/Thunder_Bay",
        "America/Iqaluit",
        "America/Pangnirtung",
        "America/Atikokan",
        "America/Winnipeg",
        "America/Rainy_River",
        "America/Resolute",
        "America/Rankin_Inlet",
        "America/Regina",
        "America/Swift_Current",
        "America/Edmonton",
        "America/Cambridge_Bay",
        "America/Yellowknife",
        "America/Inuvik",
        "America/Creston",
        "America/Dawson_Creek",
        "America/Fort_Nelson",
        "America/Vancouver",
        "America/Whitehorse",
        "America/Dawson",
        "Indian/Cocos",
        "Europe/Zurich",
        "Africa/Abidjan",
        "Pacific/Rarotonga",
        "America/Santiago",
        "America/Punta_Arenas",
        "Pacific/Easter",
        "Asia/Shanghai",
        "Asia/Urumqi",
        "America/Bogota",
        "America/Costa_Rica",
        "America/Havana",
        "Atlantic/Cape_Verde",
        "America/Curacao",
        "Indian/Christmas",
        "Asia/Nicosia",
        "Asia/Famagusta",
        "Europe/Prague",
        "Europe/Berlin",
        "Europe/Copenhagen",
        "America/Santo_Domingo",
        "Africa/Algiers",
        "America/Guayaquil",
        "Pacific/Galapagos",
        "Europe/Tallinn",
        "Africa/Cairo",
        "Africa/El_Aaiun",
        "Europe/Madrid",
        "Africa/Ceuta",
        "Atlantic/Canary",
        "Europe/Helsinki",
        "Pacific/Fiji",
        "Atlantic/Stanley",
        "Pacific/Chuuk",
        "Pacific/Pohnpei",
        "Pacific/Kosrae",
        "Atlantic/Faroe",
        "Europe/Paris",
        "Europe/London",
        "Asia/Tbilisi",
        "America/Cayenne",
        "Africa/Accra",
        "Europe/Gibraltar",
        "America/Godthab",
        "America/Danmarkshavn",
        "America/Scoresbysund",
        "America/Thule",
        "Europe/Athens",
        "Atlantic/South_Georgia",
        "America/Guatemala",
        "Pacific/Guam",
        "Africa/Bissau",
        "America/Guyana",
        "Asia/Hong_Kong",
        "America/Tegucigalpa",
        "America/Port-au-Prince",
        "Europe/Budapest",
        "Asia/Jakarta",
        "Asia/Pontianak",
        "Asia/Makassar",
        "Asia/Jayapura",
        "Europe/Dublin",
        "Asia/Jerusalem",
        "Asia/Kolkata",
        "Indian/Chagos",
        "Asia/Baghdad",
        "Asia/Tehran",
        "Atlantic/Reykjavik",
        "Europe/Rome",
        "America/Jamaica",
        "Asia/Amman",
        "Asia/Tokyo",
        "Africa/Nairobi",
        "Asia/Bishkek",
        "Pacific/Tarawa",
        "Pacific/Enderbury",
        "Pacific/Kiritimati",
        "Asia/Pyongyang",
        "Asia/Seoul",
        "Asia/Almaty",
        "Asia/Qyzylorda",
        "Asia/Qostanay",
        "Asia/Aqtobe",
        "Asia/Aqtau",
        "Asia/Atyrau",
        "Asia/Oral",
        "Asia/Beirut",
        "Asia/Colombo",
        "Africa/Monrovia",
        "Europe/Vilnius",
        "Europe/Luxembourg",
        "Europe/Riga",
        "Africa/Tripoli",
        "Africa/Casablanca",
        "Europe/Monaco",
        "Europe/Chisinau",
        "Pacific/Majuro",
        "Pacific/Kwajalein",
        "Asia/Yangon",
        "Asia/Ulaanbaatar",
        "Asia/Hovd",
        "Asia/Choibalsan",
        "Asia/Macau",
        "America/Martinique",
        "Europe/Malta",
        "Indian/Mauritius",
        "Indian/Maldives",
        "America/Mexico_City",
        "America/Cancun",
        "America/Merida",
        "America/Monterrey",
        "America/Matamoros",
        "America/Mazatlan",
        "America/Chihuahua",
        "America/Ojinaga",
        "America/Hermosillo",
        "America/Tijuana",
        "America/Bahia_Banderas",
        "Asia/Kuala_Lumpur",
        "Asia/Kuching",
        "Africa/Maputo",
        "Africa/Windhoek",
        "Pacific/Noumea",
        "Pacific/Norfolk",
        "Africa/Lagos",
        "America/Managua",
        "Europe/Amsterdam",
        "Europe/Oslo",
        "Asia/Kathmandu",
        "Pacific/Nauru",
        "Pacific/Niue",
        "Pacific/Auckland",
        "Pacific/Chatham",
        "America/Panama",
        "America/Lima",
        "Pacific/Tahiti",
        "Pacific/Marquesas",
        "Pacific/Gambier",
        "Pacific/Port_Moresby",
        "Pacific/Bougainville",
        "Asia/Manila",
        "Asia/Karachi",
        "Europe/Warsaw",
        "America/Miquelon",
        "Pacific/Pitcairn",
        "America/Puerto_Rico",
        "Asia/Gaza",
        "Asia/Hebron",
        "Europe/Lisbon",
        "Atlantic/Madeira",
        "Atlantic/Azores",
        "Pacific/Palau",
        "America/Asuncion",
        "Asia/Qatar",
        "Indian/Reunion",
        "Europe/Bucharest",
        "Europe/Belgrade",
        "Europe/Kaliningrad",
        "Europe/Moscow",
        "Europe/Simferopol",
        "Europe/Kirov",
        "Europe/Astrakhan",
        "Europe/Volgograd",
        "Europe/Saratov",
        "Europe/Ulyanovsk",
        "Europe/Samara",
        "Asia/Yekaterinburg",
        "Asia/Omsk",
        "Asia/Novosibirsk",
        "Asia/Barnaul",
        "Asia/Tomsk",
        "Asia/Novokuznetsk",
        "Asia/Krasnoyarsk",
        "Asia/Irkutsk",
        "Asia/Chita",
        "Asia/Yakutsk",
        "Asia/Khandyga",
        "Asia/Vladivostok",
        "Asia/Ust-Nera",
        "Asia/Magadan",
        "Asia/Sakhalin",
        "Asia/Srednekolymsk",
        "Asia/Kamchatka",
        "Asia/Anadyr",
        "Asia/Riyadh",
        "Pacific/Guadalcanal",
        "Indian/Mahe",
        "Africa/Khartoum",
        "Europe/Stockholm",
        "Asia/Singapore",
        "America/Paramaribo",
        "Africa/Juba",
        "Africa/Sao_Tome",
        "America/El_Salvador",
        "Asia/Damascus",
        "America/Grand_Turk",
        "Africa/Ndjamena",
        "Indian/Kerguelen",
        "Asia/Bangkok",
        "Asia/Dushanbe",
        "Pacific/Fakaofo",
        "Asia/Dili",
        "Asia/Ashgabat",
        "Africa/Tunis",
        "Pacific/Tongatapu",
        "Europe/Istanbul",
        "America/Port_of_Spain",
        "Pacific/Funafuti",
        "Asia/Taipei",
        "Europe/Kiev",
        "Europe/Uzhgorod",
        "Europe/Zaporozhye",
        "Pacific/Wake",
        "America/New_York",
        "America/Detroit",
        "America/Kentucky/Louisville",
        "America/Kentucky/Monticello",
        "America/Indiana/Indianapolis",
        "America/Indiana/Vincennes",
        "America/Indiana/Winamac",
        "America/Indiana/Marengo",
        "America/Indiana/Petersburg",
        "America/Indiana/Vevay",
        "America/Chicago",
        "America/Indiana/Tell_City",
        "America/Indiana/Knox",
        "America/Menominee",
        "America/North_Dakota/Center",
        "America/North_Dakota/New_Salem",
        "America/North_Dakota/Beulah",
        "America/Denver",
        "America/Boise",
        "America/Phoenix",
        "America/Los_Angeles",
        "America/Anchorage",
        "America/Juneau",
        "America/Sitka",
        "America/Metlakatla",
        "America/Yakutat",
        "America/Nome",
        "America/Adak",
        "Pacific/Honolulu",
        "America/Montevideo",
        "Asia/Samarkand",
        "Asia/Tashkent",
        "America/Caracas",
        "Asia/Ho_Chi_Minh",
        "Pacific/Efate",
        "Pacific/Wallis",
        "Pacific/Apia",
        "Africa/Johannesburg"
      ]
    },
    "calendarStartDateForm": {
      "title": "Calendrier hebdomadaire",
      "placeholder": "Sélectionnez une date",
      "dates": [
        {
          "id": "monday",
          "name": "Lundi"
        },
        {
          "id": "tuesday",
          "name": "Mardi"
        },
        {
          "id": "wednesday",
          "name": "Mercredi"
        },
        {
          "id": "thursday",
          "name": "Jeudi"
        },
        {
          "id": "friday",
          "name": "Vendredi"
        },
        {
          "id": "saturday",
          "name": "Samedi"
        },
        {
          "id": "sunday",
          "name": "Dimanche"
        }
      ]
    },
    "timeFormatForm": {
      "title": "Format d'heure préféré",
      "placeholder": "Sélectionnez un format"
    },
    "dateFormatForm": {
      "title": "Format de date préféré",
      "placeholder": "Sélectionnez un format"
    },
    "taskCompletionBehaviorForm": {
      "title": "Lorsque je complète une tâche",
      "placeholder": "Sélectionnez un comportement",
      "behaviors": [
        {
          "id": "useCurrentDate",
          "name": "Toujours utiliser la date du jour en tant que date de complétion"
        }
      ]
    },
    "defaultUserFilterForm": {
      "title": "Par défaut, trier les utilisateurs par",
      "placeholder": "Sélectionnez un filtre",
      "filters": [
        {
          "id": "firstName",
          "name": "Prénom"
        },
        {
          "id": "lastName",
          "name": "Nom"
        }
      ]
    }
  },
  "calendar": {
    "january": "Janvier",
    "february": "Février",
    "march": "Mars",
    "april": "Avril",
    "may": "Mai",
    "june": "Juin",
    "july": "Juillet",
    "august": "Août",
    "september": "Septembre",
    "october": "Octobre",
    "november": "Novembre",
    "december": "Décembre",
    "monday": "L",
    "tuesday": "M",
    "wednesday": "M",
    "thursday": "J",
    "friday": "V",
    "saturday": "S",
    "sunday": "D",
    "inputLabel": "Année",
    "weekends": "Week-Ends",
    "holidays": "Ferié",
    "clear": "Effacer",
    "today": "Aujourd'hui",
    "unavailability": "Indisponibilités",
    "creationMenu": {
      "button": "Ajouter",
      "createUnavailability": "Indisponibilité",
      "createTask": "Tâche",
      "createEvent": "Événement",
      "createMilestone": "Jalon",
      "selectProject": "Sélectionner un projet",
      "list": "Dans :",
      "start": "Début :",
      "end": "Fin :",
      "reason": "Raison :",
      "participants": "Participants :",
      "customFields": "Champs personnalisés :",
      "description": "Description :",
      "descriptionPlaceholder": "Ajouter une description",
      "submit": "Créer"
    }
  },
  "gantt": {
    "january": "Janvier",
    "february": "Février",
    "march": "Mars",
    "april": "Avril",
    "may": "Mai",
    "june": "Juin",
    "july": "Juillet",
    "august": "Août",
    "september": "Septembre",
    "october": "Octobre",
    "november": "Novembre",
    "december": "Décembre",
    "monday": "Lundi",
    "tuesday": "Mardi",
    "wednesday": "Mercredi",
    "thursday": "Jeudi",
    "friday": "Vendredi",
    "saturday": "Samedi",
    "sunday": "Dimanche",
    "inputLabel": "Année",
    "details": {
      "views": {
        "dates": "Dates",
        "progress": "%",
        "timeSpent": "Heures"
      },
      "title": "Détails",
      "startDate": "Début",
      "endDate": "Fin",
      "duration": "Durée",
      "estimated": "Estimé",
      "allocated": "Alloué",
      "spent": "Passé",
      "progress": "% réalisé",
      "name": "Nom"
    },
    "tasksContextualMenu": {
      "edit": "Éditer",
      "move": "Déplacer",
      "duplicate": "Dupliquer",
      "remove": "Supprimer"
    },
    "resizePopup": {
      "startDate": "Début",
      "endDate": "Fin"
    },
    "workLoadsToggle": "Charges",
    "delayToggle": "Retard",
    "derivationToggle": "Dérive"
  },
  "workLoads": {
    "title": "Charges",
    "labels": {
      "name": "Nom",
      "capacity": "Capacité",
      "groups": "Groupe",
      "function": "Fonction"
    }
  },
  "timeRecordsListingConfiguration": {
    "title": "Configuration des colonnes",
    "name": "Nom du profil de configuration",
    "roles": "Configurer pour",
    "columns": "Afficher",
    "columnNames": {
      "date": "Date",
      "resourceTask": "Ressource / Tâche",
      "project": "Projet",
      "timeSpent": "Temps",
      "validation": "Validation"
    },
    "addColumn": "Ajouter",
    "addProfile": "Ajouter une configuration",
    "cancel": "Annuler",
    "add": "Ajouter",
    "remove": "Supprimer",
    "edit": "Modifier"
  },
  "weekTimeRecords": {
    "title": "Saisies de la semaine",
    "empty": "Aucune saisie cette semaine",
    "columns": {
      "date": "Date",
      "resourceTask": "Ressource / Tâche",
      "project": "Projet",
      "timeSpent": "Temps",
      "validation": "Validation"
    },
    "validated": "Validé",
    "toValidate": "À valider",
    "edit": "Modifier la saisie",
    "remove": "Supprimer la saisie"
  },
  "timeRecordRemoval": {
    "title": "Supprimer la saisie de temps",
    "message": "Voulez-vous vraiment supprimer cette saisie de temps ?",
    "cancel": "Annuler",
    "confirm": "Supprimer"
  },
  "timeRecordCriteria": {
    "title": "Saisie de temps",
    "task": "Tâche",
    "resource": "Ressource",
    "date": "Date",
    "criteria": "Critères de la saisie",
    "open": "Modifier la saisie",
    "timeSpent": "Temps passé (h)",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "close": "Fermer"
  },
  "timeSheet": {
    "title": "Suivi temporel",
    "button": "+ Ajouter",
    "estimatedTime": "Estimé",
    "allocatedTime": "Alloué",
    "spentTime": "Passé",
    "spentTimeInWeek": "Passé (semaine)",
    "remainingTime": "Restant",
    "workDoneToggle": "Tâches terminées",
    "percent": "% réalisé",
    "detailsToggle": "Détails",
    "deactivatedProjectsToggle": "Désactivé",
    "deactivatedResourcesToggle": "Ressources désactivées",
    "removedResourcesToggle": "Ressources retirées du projet",
    "removedProjectsToggle": "Projets retirés",
    "includeProjectsWithoutSpentTimeToggle": "Temps passé intégré = 0",
    "includeProjectsWithoutSpentTimeInWeekToggle": "Temps passé (semaine) intégré = 0",
    "includeProjectsWithoutNonIntegratedSpentTimeInWeekToggle": "Temps passé (semaine) = 0",

    "week": "Semaine",
    "weekSelector": "Semaine du {{-from}} au {{-to}}",
    "moveToToday": "Aller à aujourd'hui",
    "lockDate": "Verrouillage",
    "tutorial": {
      "title": "Vous n’avez aucune allocation sur ce projet.",
      "action": "Allouez une ressource sur une tâche",
      "message": "afin de faire apparaître le suivi temporel du projet."
    },
    "filters": {
      "title": "Filtrer par : ",
      "default": "Aucun filtre",
      "allProjects": "Tous les projets",
      "allResources": "Tout le monde",
      "and": "Et par"
    }
  },
  "quickListCreation": {
    "add": "Ajouter une liste",
    "placeholder": "Nommer la nouvelle liste",
    "cancel": "Annuler"
  },
  "projectReportSubmission": {
    "title": "Faire un compte rendu",
    "nameTitle": "Nom du compte rendu",
    "namePlaceholder": "Ex : Compte rendu 23/03/2022",
    "defaultTitle": "Compte rendu du {{- date }}",
    "submit": "Envoyer",
    "templateSelect": "Modèle de rapport",
    "templateSelectPlaceholder": "Sélectionner un modèle"
  },
  "projectReport": {
    "title": "Compte rendu",
    "submissionDate": "Fait le",
    "by": "par",
    "submit": "Modifier",
    "remove": "Supprimer",
    "duplicate": "Dupliquer",
    "downloadPdf": "Télécharger"
  },
  "milestoneCompletion": {
    "title": "Marquer ce jalon comme terminé",
    "subTitle": "A quelle date souhaiteriez-vous marquer ce jalon comme terminé ?",
    "today": "Aujourd'hui",
    "endDate": "Date de fin prévue",
    "anotherDate": "Une autre date",
    "placeholder": "Choisir une date",
    "cancel": "Annuler",
    "submit": "Confirmer"
  },
  "taskCompletion": {
    "title": "Marquer cette tâche comme terminée",
    "subTitle": "La tâche mobilise plusieurs ressources. Préférez-vous compléter votre allocation ou prendre en charge l'intégralité de la tâche ?",
    "completionDate": "A quelle date souhaiteriez-vous marquer cette tâche comme terminée ?",
    "today": "Aujourd'hui",
    "endDate": "Date de fin prévue",
    "anotherDate": "Une autre date",
    "placeholder": "Choisir une date",
    "markOnlyMyAllocation": "Marquer uniquement mon allocation à 100%",
    "markEntireTaskCompleted": "Marquer toute la tâche comme terminée",
    "cancel": "Annuler",
    "submit": "Confirmer"
  },
  "projectExternalLinks": {
    "title": "Liens pratiques externes",
    "namePlaceholder": "Nom",
    "urlPlaceholder": "Lien"
  },
  "attachments": {
    "files": "Fichiers",
    "noFile": "Pas de fichier",
    "dropFileHere": "Déposez un fichier ou téléchargez le ici.",
    "add": "Ajouter"
  },
  "unavailabilityReasons": {
    "holidays": "Vacances",
    "sickLeave": "Maladie",
    "other": "Autre"
  },
  "unavailability": {
    "unavailability": "Indisponibilité",
    "creation": {
      "title": "Créer une indisponibilité",
      "editTitle": "Éditer une indisponibilité",
      "name": "Nom de l'indisponibilité",
      "namePlaceholder": "Nommer l'indisponibilité",
      "for": "Pour",
      "forPlaceholder": "Sélectionner",
      "me": "Moi",
      "reason": "Type",
      "reasonPlaceholder": "Sélectionner un type",
      "startDateTitle": "Début:",
      "startDatePlaceholder": "Sélectionner une date",
      "endDateTitle": "Fin:",
      "endDatePlaceholder": "Sélectionner une date",
      "fullDay": "Toute la journée",
      "partialDay": "Journée partielle",
      "durationHour": "De:",
      "durationDay": "Le:",
      "partialEndTime": "À:",
      "cancel": "Annuler",
      "submit": "Créer",
      "edit": "Éditer",
      "remove": "Supprimer"
    }
  },
  "appNotifications": {
    "exportBiRun": {
      "success": "Votre export BI est terminé, les fichiers sont disponibles dans les documents",
      "partial": "Votre export BI est terminé partiellement, certains fichiers n'ont pas pu être générés",
      "failure": "Votre export BI a échoué",
      "requestFailure": "L'export BI n'a pas pu être lancé",
      "retrieveFailure": "Impossible de récupérer l'état de l'export BI"
    },
    "close": "Fermer",
    "adjustWorkload": {
      "success": "Votre saisie de charge a été enregistrée avec succès",
      "failure": "La saisie de charge n'a pas pu être enregistrée",
      "forbidden": "Vous n'avez pas les droits pour modifier la charge de cette ressource",
      "notFound": "Cette ressource ou ce projet est introuvable"
    },
    "adjustCapacity": {
      "success": "Votre ajustement de capacité a été enregistré avec succès",
      "failure": "L'ajustement de capacité n'a pas pu être enregistré",
      "forbidden": "Vous n'avez pas les droits pour ajuster la capacité de cette ressource",
      "notFound": "Cette ressource est introuvable"
    },
    "authenticate": {
      "invalidCredentials": "Vos identifiants ne correspondent à aucun compte",
      "unExpectedError": "Une erreur inattendue est survenue"
    },
    "changePassword": {
      "success": "Votre mot de passe a été édité avec succès",
      "failure": "Votre mot de passe n'a pas pu être édité"
    },
    "fillAccount": {
      "success": "Votre compte a été validé avec succès",
      "failure": "Votre compte n'a pas pu être validé",
      "alreadyConfirmed": "Vous avez déja confirmé votre inscription"
    },
    "startDiscussion": {
      "success": "Votre fil de discussion a été créé avec succès",
      "failure": "Votre fil de discussion n'a pas pu être créée"
    },
    "retrieveZones": {
      "planzoneNotFound": "La planzone fournie n'a pas été trouvée",
      "unExpectedError": "Une erreur inattendue est apparue"
    },
    "retrieveZone": {
      "zoneNotFound": "La zone fournie n'a pas été trouvée",
      "unExpectedError": "Une erreur inattendue est survenue"
    },
    "retrieveEvent": {
      "notFound": "L'événement n’existe pas ou a été supprimé.",
      "failure": "Une erreur inattendue est survenue"
    },
    "retrieveMilestone": {
      "notFound": "Le jalon n'existe pas ou a été supprimé.",
      "failure": "Une erreur inattendue est survenue"
    },
    "retrieveTask": {
      "notFound": "La tâche n'existe pas ou a été supprimée",
      "failure": "Une erreur inattendue est survenue"
    },
    "retrieveList": {
      "notFound": "La liste n'existe pas ou a été supprimée.",
      "failure": "Une erreur inattendue est survenue"
    },
    "removeZone": {
      "success": "Votre zone a été supprimée avec succès",
      "failure": "Une erreur inattendue est survenue"
    },
    "removeEvent": {
      "notFound": "L'événement n’existe pas ou a été supprimé.",
      "success": "Votre évènement a été créée avec succès.",
      "failure": "Une erreur inattendue est survenue"
    },
    "transferProjects": {
      "success": "Vos projets ont été transférés avec succès .",
      "failure": "Une erreur inattendue est survenue"
    },
    "createZone": {
      "success": "Votre zone a été créée avec succès",
      "unExpectedError": "Une erreur inattendue est survenue",
      "invalidName": "Vous devez fournir un nom pour la zone",
      "duplicateZone": "Vous ne pouvez pas avoir deux zones avec le même nom"
    },
    "editZone": {
      "success": "Votre zone a été modifiée avec succès",
      "unExpectedError": "Une erreur inattendue est survenue",
      "invalidName": "Vous devez fournir un nom pour la zone",
      "duplicateZone": "Vous ne pouvez pas avoir deux zones avec le même nom"
    },
    "editTask": {
      "emptyName": "Vous devez fournir un nom pour votre tâche",
      "duplicateName": "Ce nom de tâche est déjà utilisé",
      "invalidDateRange": "La date de début de la tâche ne peut pas être après sa date de fin et vice-versa",
      "startDateOutOfBound": "La date de début ne peut ne peut pas être antérieur à celle de ses listes parentes",
      "startDateOutOfBoundProject": "La date de début de cet élément ne peut être avant son la date de début du projet.",
      "listNotFound": "La liste parente n'existe pas",
      "success": "Votre tâche a été modifiée avec succès",
      "failure": "Votre tâche n'a pas pu être éditée",
      "unExpectedError": "Une erreur inattendue est survenue"
    },
    "editEvent": {
      "emptyName": "Vous devez fournir un nom pour votre événement",
      "duplicateName": "Ce nom d'événement est déjà utilisé",
      "invalidDateRange": "La date de début de l'événement ne peut pas être après sa date de fin et vice versa",
      "startDateOutOfBound": "La date de début ne peut pas être antérieure à celle de ses listes parentes",
      "startDateOutOfBoundProject": "La date de début de cet élément ne peut être avant son la date de début du projet.",
      "notFound": "L'événement n'existe pas ou a été supprimé",
      "listNotFound": "La liste parente n'existe pas",
      "success": "Votre événement a été modifié avec succès",
      "failure": "Votre événement n'a pas pu être modifié",
      "unExpectedError": "Une erreur inattendue est survenue"
    },
    "editList": {
      "emptyName": "Vous devez fournir un nom pour votre liste.",
      "duplicateName": "Ce nom de liste est déjà utilisé. Veuillez en choisir un autre.",
      "invalidDateRange": "La date de début de la liste ne peut pas être après sa date de fin, et vice versa. Veuillez ajuster les dates.",
      "startDateOutOfBound": "La date de début ne peut pas être antérieure à celle de ses listes parentes. Veuillez ajuster la date de début.",
      "startDateOutOfBoundProject": "La date de début de cet élément ne peut être avant son la date de début du projet.",
      "listNotFound": "La liste parente associée à cette liste n'existe pas. Veuillez sélectionner une liste valide.",
      "success": "Votre liste a été modifiée avec succès.",
      "failure": "Votre liste n'a pas pu être modifiée. Veuillez vérifier les informations fournies.",
      "unExpectedError": "Une erreur inattendue est survenue."
    },
    "createProject": {
      "success": "Votre projet a été créé avec succès",
      "failure": "Votre projet n'a pas pu être créé"
    },
    "createAccount": {
      "success": "Votre compte a été créé avec succès",
      "failure": "Votre compte n'a pas pu être créé"
    },
    "confirmAccountCreation": {
      "invalidPassword": "Votre mot de passe n'est pas valide",
      "invalidPasswordConfirmation": "Vos mots de passe ne correspondent pas",
      "invalidUsername": "Votre nom d'utilisateur est invalide",
      "invalidCompany": "Le nom de votre entreprise est invalide",
      "missingAddress": "Vous devez fournir une adresse avec votre planzone",
      "isPlanzoneNameInvalid": "Le nom de votre planzone n'est pas valide",
      "isPlanzoneDomainInvalid": "Votre domaine planzone est invalide",
      "unExpectedError": "Une erreur inattendue est apparue",
      "success": "Votre compte a été créé avec succès, vous pouvez maintenant vous connecter"
    },
    "createTaskStatus": {
      "success": "Votre statut a été créé avec succès",
      "failure": "Votre statut n'a pas pu être créé"
    },
    "editTaskStatus": {
      "success": "Votre statut a été édité avec succès",
      "failure": "Votre statut n'a pas pu être édité"
    },
    "editProjectWeatherReport": {
      "success": "Votre météo projet a été éditée avec succès",
      "failure": "Votre météo projet n'a pas pu être éditée"
    },
    "addResourceGroup": {
      "success": "Votre groupe a été créé avec succès",
      "failure": "Votre groupe n'a pas pu être créé"
    },
    "editResourceGroup": {
      "success": "Votre groupe de ressources projet a été édité avec succès",
      "failure": "Votre groupe de ressources projet n'a pas pu être édité"
    },
    "editUserPreferences": {
      "success": "Vos préférences ont été éditées avec succès",
      "failure": "Vos préférences n'ont pas pu être éditées"
    },
    "createList": {
      "emptyName": "Veuillez fournir un nom pour votre liste.",
      "duplicateName": "Le nom de cette liste est déjà utilisé. Veuillez en choisir un autre.",
      "invalidDateRange": "La date de début de la liste ne peut pas être après sa date de fin, et vice versa. Veuillez ajuster les dates.",
      "startDateOutOfBound": "La date de début ne peut pas être antérieure à celle de ses listes parentes. Veuillez ajuster la date de début.",
      "listNotFound": "La liste parente associée à cette liste n'existe pas. Veuillez sélectionner une liste valide.",
      "success": "Votre liste a été créée avec succès.",
      "failure": "Votre liste n'a pas pu être créée. Veuillez vérifier les informations fournies."
    },
    "createTask": {
      "emptyName": "Vous devez fournir un nom pour votre tâche",
      "duplicateName": "Ce nom de tâche est déjà utilisé",
      "invalidDateRange": "La date de début de la tâche ne peut pas être après sa date de fin et vice-versa",
      "startDateOutOfBound": "La date de début ne peut ne peut pas être antérieur à celle de ses listes parentes",
      "listNotFound": "La liste parente n'existe pas",
      "success": "Votre tâche à été créée avec succès",
      "failure": "Votre tâche n'a pas pu être créée"
    },
    "createEvent": {
      "emptyName": "Vous devez fournir un nom pour votre évènement",
      "duplicateName": "Ce nom d'évènement est déjà utilisé",
      "invalidDateRange": "La date de début de l'évènement ne peut pas être après sa date de fin et vice-versa",
      "startDateOutOfBound": "La date de début ne peut ne peut pas être antérieur à celle de ses listes parentes",
      "listNotFound": "La liste parente n'existe pas",
      "success": "Votre évènement a été créée avec succès.",
      "failure": "Votre évènement n'a pas pu être créée"
    },
    "removeResourceGroup": {
      "success": "Votre groupe de ressources projet à été supprimé avec succès",
      "failure": "Votre groupe de ressources projet n'a pas pu être supprimé"
    },
    "removeTask": {
      "notFound": "La tâche n'existe pas ou a été supprimée.",
      "success": "Votre tâche a été supprimée avec succès",
      "failure": "Votre tâche n'a pas pu être supprimée"
    },
    "removeOrganizationalUnit": {
      "notFound": "L'unité organisationnelle n'existe pas ou a déjà été supprimée.",
      "success": "L'unité organisationnelle a été supprimée avec succès",
      "failure": "L'unité organisationnelle n'a pas pu être supprimée"
    },
    "moveOrganizationalUnit": {
      "cycle": "Impossible de déplacer une unité vers l'une de ses propres sous-unités.",
      "duplicateName": "Une unité du même nom existe déjà dans la destination choisie.",
      "success": "L'unité organisationnelle a été déplacée avec succès",
      "failure": "L'unité organisationnelle n'a pas pu être déplacée"
    },
    "updateOrganizationalUnit": {
      "success": "L'unité organisationnelle a été modifiée avec succès",
      "failure": "L'unité organisationnelle n'a pas pu être modifiée"
    },
    "removeMilestone": {
      "notFound": "Le jalon n'existe pas ou a été supprimé.",
      "success": "Votre jalon a été supprimé avec succès",
      "failure": "Votre jalon n'a pas pu être supprimé"
    },
    "removeProject": {
      "success": "Votre projet a été supprimé avec succès",
      "failure": "Votre projet n'a pas pu être supprimé"
    },
    "removeList": {
      "notFound": "La liste n'existe pas ou a été supprimée.",
      "success": "Votre liste de tâches a été supprimée avec succès",
      "failure": "Votre liste de tâches n'a pas pu être supprimée"
    },
    "addPlanzoneMaterialResource": {
      "success": "Votre ressource à été créée avec succès",
      "failure": "Votre ressource n'a pas pu être créée"
    },
    "addPlanzoneVirtualResource": {
      "success": "Votre ressource à été créée avec succès",
      "failure": "Votre ressource n'a pas pu être créée"
    },
    "addProjectMaterialResource": {
      "success": "Votre ressource à été créée avec succès",
      "failure": "Votre ressource n'a pas pu être créée"
    },
    "addProjectVirtualResource": {
      "success": "Votre ressource à été créée avec succès",
      "failure": "Votre ressource n'a pas pu être créée"
    },
    "allocateResources": {
      "duplicateAllocation": "La ressource a déjà été allouée sur la tâche.",
      "success": "Vos ressources ont été allouées avec succès",
      "failure": "Vos ressources n'ont pas pu être allouées"
    },
    "addResourceToResourceGroup": {
      "success": "Votre ressource a été ajoutée avec succès à ce groupe",
      "failure": "Votre ressource n'a pas pu être ajoutée à ce groupe"
    },
    "removeResourceFromResourceGroup": {
      "success": "Votre ressource a été retirée avec succès de ce groupe",
      "failure": "Votre ressource n'a pas pu être retirée de ce groupe"
    },
    "removeResourceFromProject": {
      "success": "Ce membre de l'équipe a été retiré avec succès",
      "failure": "Ce membre de l'équipe n'a pas pu être retiré"
    },
    "removeResourceFromPlanzone": {
      "success": "La ressource a bien été supprimée",
      "failure": "Impossible de supprimer cette ressource"
    },
    "editAllocation": {
      "success": "Votre allocation a été éditée avec succès",
      "failure": "Votre allocation n'a pas pu être éditée"
    },
    "removeAllocation": {
      "notFound": "L’allocation n’existe pas ou a été supprimée",
      "success": "Votre allocation a été supprimée avec succès",
      "failure": "Votre allocation n'a pas pu être supprimée"
    },
    "editMilestone": {
      "emptyName": "Veuillez fournir un nom pour votre jalon.",
      "duplicateName": "Le nom de ce jalon est déjà utilisé. Veuillez en choisir un autre.",
      "endDateOutOfBound": "La date de début ne peut pas être antérieure à celle de ses listes parentes. Veuillez ajuster la date de début.",
      "endDateOutOfBoundProject": "La date de début de cet élément ne peut être avant son la date de début du projet.",
      "listNotFound": "La liste parente associée à ce jalon n'existe pas. Veuillez sélectionner une liste valide.",
      "success": "Votre jalon a été modifié avec succès.",
      "failure": "Votre jalon n'a pas pu être édité. Veuillez vérifier les informations fournies.",
      "unExpectedError": "Une erreur inattendue est survenue lors de la modification du jalon. Veuillez réessayer ultérieurement."
    },
    "removeTaskStatus": {
      "success": "Votre statut a été supprimé avec succès",
      "failure": "Votre statut n'a pas pu être supprimé"
    },
    "addPlanzoneResourceToProject": {
      "success": "Votre ressource a été ajoutée avec succès à votre projet",
      "failure": "Votre ressource n'a pas pu être ajoutée à votre projet"
    },
    "addProjectExternalLink": {
      "success": "Votre lien a été ajouté avec succès à votre projet",
      "failure": "Votre lien n'a pas pu être ajouté à votre projet"
    },
    "assignTag": {
      "success": "Votre tag a été attribué avec succès",
      "failure": "Votre étiquette n'a pas pu être attribué"
    },
    "changePlanzone": {
      "failure": "Un problème inattendu est survenu"
    },
    "createMilestone": {
      "emptyName": "Vous devez fournir un nom pour votre jalon.",
      "duplicateName": "Ce nom de jalon est déjà utilisé. Veuillez en choisir un autre.",
      "endDateOutOfBound": "La date de fin ne peut pas être antérieure à celle de ses listes parentes. Veuillez ajuster la date de fin.",
      "listNotFound": "La liste parente associée à ce jalon n'existe pas. Veuillez sélectionner une liste valide.",
      "success": "Votre jalon a été créé avec succès.",
      "failure": "Votre jalon n'a pas pu être créé. Veuillez vérifier les informations fournies."
    },
    "createProjectStatus": {
      "success": "Votre statut de projet a été créé avec succès",
      "failure": "Votre statut de projet n'a pas pu être créé"
    },
    "editPersonalWeeklyCalendar": {
      "success": "Votre calendrier a été édité avec succès",
      "failure": "Votre calendrier n'a pas pu être édité"
    },
    "editProject": {
      "success": "Votre projet a été édité avec succès",
      "failure": "Votre projet n'a pas pu être édité"
    },
    "editProjectExternalLink": {
      "success": "Votre lien a été modifié avec succès",
      "failure": "Votre lien n'a pas pu être édité"
    },
    "logOut": {
      "failure": "Un problème inattendu est survenu"
    },
    "markMilestoneAsCompleted": {
      "success": "Votre jalon a été marqué comme terminé avec succès.",
      "failure": "Un problème inattendu est survenu"
    },
    "moveKanbanTask": {
      "failure": "Un problème inattendu est survenu"
    },
    "moveListElement": {
      "failure": "Une erreur s'est produite",
      "startDateOutOfBoundProject": "La date de début ne peut pas précéder la date de début du projet",
      "startDateOutOfBound": "La date de début ne peut pas précéder la date de début de la liste parente",
      "endDateOutOfBoundProject": "La date de fin ne peut pas précéder la date de début du projet",
      "endDateOutOfBound": "La date de fin ne peut pas précéder la date de début de la liste parente"
    },
    "removeProjectExternalLink": {
      "success": "Votre lien a été supprimé avec succès",
      "failure": "Votre lien n'a pas pu être supprimé"
    },
    "removeProjectStatus": {
      "success": "Votre statut de projet a été supprimé avec succès",
      "failure": "Votre statut de projet n'a pas pu être supprimé"
    },
    "removeTag": {
      "success": "Votre tag a été supprimé avec succès",
      "failure": "Votre tag n'a pas pu être supprimé"
    },
    "editProjectReportTemplate": {
      "success": "Votre modèle a été édité avec succès",
      "failure": "Votre modèle n'a pas pu être édité"
    },
    "submitProjectReport": {
      "success": "Votre rapport a été envoyé avec succès",
      "failure": "Votre rapport n'a pas pu être envoyé"
    },
    "exportData": {
      "failure": "Vos rapports n'ont pas pu être exportés"
    },
    "configureProjectTools": {
      "success": "Vos vues ont été éditées avec succès",
      "failure": "Vos vues n'ont pas pu être éditées"
    },
    "editResource": {
      "success": "Votre ressource a été éditée avec succès",
      "failure": "Votre ressource n'a pas pu être éditée"
    },
    "editProjectResource": {
      "success": "Votre ressource projet a été éditée avec succès",
      "failure": "Votre ressource projet n'a pas pu être éditée"
    },
    "markTaskAsCompleted": {
      "completionDateOutOfBound": "La date de complétion de la tâche ne peut pas être antérieure à sa date de début.",
      "notFound": "La tâche n'existe pas ou a été supprimée .",
      "failure": "Votre tâche n'a pas pu être complétée"
    },
    "updatePlanzoneContacts": {
      "success": "Vos contacts ont été éditée avec succès",
      "failure": "Vos contacts n'ont pas pu être éditée"
    },
    "createProjectModelFromProject": {
      "success": "Votre modèle de projet a été crée avec succès",
      "failure": "Votre modèle de projet n'a pas pu être crée"
    },
    "createProjectPortfolio": {
      "success": "Votre portefeuille de projet a été créé avec succès.",
      "duplicateName": "Votre portefeuille de projet doit avoir un nom unique",
      "emptyName": "Votre portefeuille de projet doit avoir un nom"
    },
    "editProjectPortfolio": {
      "success": "Votre portefeuille de projet a été créé avec succès.",
      "duplicateName": "Votre portefeuille de projet doit avoir un nom unique",
      "emptyName": "Votre portefeuille de projet doit avoir un nom"
    },
    "inviteMembers": {
      "failureSingular": "Une invitation n'a pas pu être envoyée",
      "failurePlural": "{{failedInvitationNbr}} invitations n'ont pas pu être envoyée(s)"
    },
    "sendActivityReport": {
      "success": "Votre rapport d'activité à été envoyé avec succès",
      "failure": "Votre rapport d'activité n'a pas pu être envoyé"
    },
    "uploadDocument": {
      "success": "Votre document a été envoyé avec succès",
      "failure": "Votre document n'a pas pu être envoyé"
    },
    "downloadDocumentContent": {
      "success": "Votre document a été téléchargé avec succès",
      "failure": "Votre document n'a pas pu être téléchargé"
    },
    "downloadFolderContent": {
      "success": "Votre dossier a été téléchargé avec succès",
      "failure": "Votre dossier n'a pas pu être téléchargé"
    },
    "saveTimeRecord": {
      "failure": "Votre feuille de temps n'a pas pu être éditée",
      "timesheetDeadlineExceeded": "La date limite de saisie des temps est dépassée. Vous ne pouvez plus modifier vos temps passés à compter du de la date de vérrouillage."
    },
    "validateTimeRecordsUpToDate": {
      "failure": "Votre feuille de temps n'a pas pu être validée"
    },
    "createUnavailability": {
      "success": "Votre indisponibilité a été créée avec succès.",
      "failure": "Votre indisponibilité n'a pas pu être créée.",
      "emptyName": "Vous devez fournir un nom.",
      "invalidUnavailabilityDates": "Votre indisponibilité se superpose avec une autre indisponibilité.",
      "invalidUnavailabilityNonWorkedHoursCount": "Le nombre d'heures indiqué dépasse le nombre d'heures travaillé.",
      "invalidDateRange": "La date de fin ne peut pas être avant la date de début.",
      "invalidStartDate": "La date de début spécifiée n'est pas valide.",
      "invalidResource": "Vous devez spécifier le membre indisponible.",
      "invalidReason": "Vous devez fournir un type d'indisponibilité."
    },
    "editUnavailability": {
      "success": "Votre indisponibilité a été créée avec succès.",
      "failure": "Votre indisponibilité n'a pas pu être créée.",
      "emptyName": "Vous devez fournir un nom.",
      "invalidUnavailabilityDates": "Votre indisponibilité se superpose avec une autre indisponibilité.",
      "invalidUnavailabilityNonWorkedHoursCount": "Le nombre d'heures indiqué dépasse le nombre d'heures travaillé.",
      "invalidDateRange": "La date de fin ne peut pas être avant la date de début.",
      "invalidStartDate": "La date de début spécifiée n'est pas valide.",
      "invalidResource": "Vous devez spécifier le membre indisponible.",
      "invalidReason": "Vous devez fournir un type d'indisponibilité."
    },
    "createCalendarHolidays": {
      "success": "Votre calendrier de jours fériés a été créé avec succès",
      "failure": "Votre calendrier de jours fériés n'a pas pu être créé"
    },
    "removeCalendarHolidays": {
      "success": "Votre calendrier de jours fériés a été supprimé avec succès",
      "failure": "Votre calendrier de jours fériés n'a pas pu être supprimé"
    },
    "removeHoliday": {
      "success": "Votre jour  férié a été supprimé avec succès",
      "failure": "Votre  jour  férié n'a pas pu être supprimé"
    },
    "useProjectModel": {
      "invalidProjectName": "Votre projet n'a pas pu être créé à partir d'un modèle, car son nom est invalide"
    },
    "duplicateProject": {
      "invalidProjectName": "Le projet n’a pas pu être dupliqué car le nom est invalide"
    }
  },
  "strategicAxesPage": {
    "title": "Axes stratégiques",
    "navigation": "Axes stratégiques",
    "createStrategicAxis": "Axe stratégique",
    "edit": "Modifier",
    "remove": "Supprimer",
    "table": {
      "strategicProjectAdequacy": "Possibilités de cohérence du projet avec la stratégie",
      "code": "Code",
      "strategicAxis": "Axe stratégique",
      "weight": "Poids"
    },
    "creation": {
      "title": "Créer un axe stratégique",
      "cancel": "Annuler",
      "submit": "Enregistrer",
      "code": "Code",
      "axe": "Axe",
      "weight": "Poids de l'objectif",
      "strategicProjectAdequacy": "Possibilités de cohérence du projet avec la stratégie",
      "placeholders": {
        "levelOne": "Ex: Fortement incohérent",
        "levelTwo": "Ex: Peu cohérent",
        "levelThree": "Ex: Neutre",
        "levelFour": "Ex: Cohérent",
        "levelFive": "Ex: Renforce la mission",
        "axeName": "Nommer l'axe stratégique",
        "code": "Code"
      }
    },
    "edition": {
      "title": "Éditer un axe stratégique",
      "cancel": "Annuler",
      "submit": "Enregistrer",
      "code": "Code",
      "axe": "Axe",
      "weight": "Poids de l'objectif",
      "strategicProjectAdequacy": "Possibilités de cohérence du projet avec la stratégie",
      "placeholders": {
        "levelOne": "Ex: Fortement incohérent",
        "levelTwo": "Ex: Peu cohérent",
        "levelThree": "Ex: Neutre",
        "levelFour": "Ex: Cohérent",
        "levelFive": "Ex: Renforce la mission",
        "axeName": "Nommer l'axe stratégique",
        "code": "Code"
      }
    },
    "removal": {
      "title": "Êtes-vous sûr de vouloir supprimer cet axe stratégique ?",
      "confirmation": "L'axe sera supprimé et retiré du score de tous les projets.",
      "cancel": "Annuler",
      "confirm": "Supprimer"
    }
  },
  "projectStrategicAxes": {
    "title": "Impact stratégique",
    "scoring": "Score stratégique du projet",
    "coherence": "Cohérence avec la stratégie",
    "score": "Score"
  },
  "moveDocument": {
    "title": "Changer de dossier",
    "placeholder": "Choisir le nouveau dossier",
    "cancel": "Annuler",
    "confirm": "Confirmer"
  },
  "moveFolder": {
    "title": "Changer de dossier",
    "placeholder": "Choisir le nouveau dossier",
    "cancel": "Annuler",
    "confirm": "Confirmer"
  },
  "moveOrganizationalUnit": {
    "title": "Déplacer l'unité organisationnelle",
    "placeholder": "Choisir la nouvelle unité parente",
    "root": "Racine (aucun parent)",
    "cancel": "Annuler",
    "confirm": "Confirmer"
  },
  "updateOrganizationalUnit": {
    "title": "Modifier « {{- name}} »",
    "name": "Nom",
    "resources": "Ressources ({{total}})",
    "cancel": "Annuler",
    "confirm": "Enregistrer"
  },
  "timesheetPage": {
    "toggle": {
      "personal": "Personnel",
      "team": "Équipe"
    },
    "resourceRemoved": "Retiré du projet",
    "noAllocation": "Allocation retirée"
  },
  "log": {
    "createTask": "{{- author }} a créé cette tâche",
    "updateTask": "{{- author }} a modifié cette tâche",
    "deleteTask": "{{- author }} a supprimé cette tâche",
    "createEvent": "{{- author }} a créé cet événement",
    "updateEvent": "{{- author }} a modifié cet événement",
    "deleteEvent": "{{- author }} a supprimé cet événement",
    "createMilestone": "{{- author }} a créé ce jalon",
    "updateMilestone": "{{- author }} a modifié ce jalon",
    "deleteMilestone": "{{- author }} a supprimé ce jalon",
    "createProject": "{{- author }} a créé ce projet",
    "updateProject": "{{- author }} a modifié ce projet",
    "deleteProject": "{{- author }} a supprimé ce projet",
    "createActivity": "{{- author }} a créé la liste",
    "updateActivity": "{{- author }} a modifié la liste",
    "deleteActivity": "{{- author }} a supprimé la liste"
  },
  "projectLogs": {
    "title": "Logs du projet",
    "copy": "Copier",
    "log": {
      "createTask": "{{- author }} a créé la tâche",
      "updateTask": "{{- author }} a modifié la tâche",
      "deleteTask": "{{- author }} a supprimé la tâche",
      "createEvent": "{{- author }} a créé l'événement",
      "updateEvent": "{{- author }} a modifié l'événement",
      "deleteEvent": "{{- author }} a supprimé l'événement",
      "createMilestone": "{{- author }} a créé le jalon",
      "updateMilestone": "{{- author }} a modifié le jalon",
      "deleteMilestone": "{{- author }} a supprimé le jalon",
      "createProject": "{{- author }} a créé le projet",
      "updateProject": "{{- author }} a modifié le projet",
      "deleteProject": "{{- author }} a supprimé le projet",
      "createActivity": "{{- author }} a créé la liste",
      "updateActivity": "{{- author }} a modifié la liste",
      "deleteActivity": "{{- author }} a supprimé la liste"
    }
  },
  "notificationsPage": {
    "title": "Notifications",
    "filter": {
      "title": "Filtrer par type",
      "placeholder": "Tous les types",
      "clear": "Effacer le filtre",
      "selection": {
        "MENTION_IN_COMMENT": "Mentionné(e) dans un commentaire",
        "ADDED_TO_TASK": "Affecté(e) à une tâche",
        "ADDED_TO_PROJECT": "Affecté(e) à un projet",
        "ADDED_TO_EVENT": "Invité(e) à un événement",
        "DELAYED_TASK": "Tâche en retard",
        "EXPORT_BI_FINISHED": "Export BI terminé"
      }
    }
  },
  "planzoneLogsPage": {
    "title": "Logs de la planzone",
    "filter": {
      "title": "Filtrer par :",
      "placeholder": "Séléctionnez un type de log",
      "clear": "Effacer les filtres",
      "selection": {
        "PLANZONE": "Planzone",
        "ZONE": "Zone",
        "PROJECT": "Projet",
        "ACTIVITY": "Liste",
        "TASK": "Tâche",
        "EVENT": "Événement",
        "MILESTONE": "Jalon",
        "RESOURCE": "Ressource",
        "UNAVAILABILITY": "Indisponibilité",
        "COST_PROFILE": "Profil de coût",
        "PLANZONE_RESOURCE": "Ressources de Planzone",
        "PROJECT_RESOURCE": "Ressources de projet",
        "PROJECT_RESOURCE_GROUP": "Groupe de ressources de projet",
        "PROJECT_STATUS": "Statuts de projet",
        "STATUS": "Statuts",
        "STRATEGIC_AXES": "Axes stratégiques",
        "TIME_RECORD": "Feuilles de temps",
        "AUTHENTICATION": "Authentification",
        "EMAIL": "Email",
        "NOTIFICATION": "Notifications",
        "PORTFOLIO": "Portefeuilles"
      }
    },
    "description": {
      "createMilestone": "A créé le jalon {{- name }} dans le projet {{- parent }}",
      "createEvent": "A créé l'événement {{- name }} dans le projet {{- parent }}",
      "createTask": "A créé la tâche {{- name }} dans le projet {{- parent }}",
      "createActivity": "A créé la liste {{- name }} dans le projet {{- parent }}",
      "createProject": "A créé le projet {{- name }}",
      "createZone": "A créé la zone {{- name }}",
      "deleteMilestone": "A supprimé le jalon {{- name }} dans le projet {{- parent }}",
      "deleteEvent": "A supprimé l'événement {{- name }} dans le projet {{- parent }}",
      "deleteTask": "A supprimé la tâche {{- name }} dans le projet {{- parent }}",
      "deleteActivity": "A supprimé la liste {{- name }} dans le projet {{- parent }}",
      "deleteProject": "A supprimé le projet {{- name }}",
      "deleteZone": "A supprimé la zone {{- name }}",
      "createProjectPortfolios": "A créé le portefeuille {{- name }}",
      "deleteProjectPortfolios": "A supprimé le portefeuille {{- name }}",
      "updateProjectPortfolios": {
        "name": "A modifié le nom du portefeuille {{- name }}",
        "color": "A modifié la couleur du portefeuille {{- name }}",
        "description": "A modifié la description du portefeuille {{- name }}",
        "project": "A modifié les projets du portefeuille {{- name }}: {{- parent }}",
        "removeProject": "A retiré au portefeuille {{- name }} les projets: {{- parent }}",
        "addProject": "A ajouté au portefeuille {{- name }} les projets: {{- parent }}"
      },
      "updateMilestone": {
        "tags": "A modifié les tags du jalon {{- name }} dans le projet {{- parent }}",
        "name": "A modifié le nom du jalon {{- name }} dans le projet {{- parent }}",
        "description": "A modifié la description du jalon {{- name }} dans le projet {{- parent }}",
        "endDate": "A modifié la date de fin du jalon {{- name }} dans le projet {{- parent }}",
        "move": "A déplacé le jalon {{- name }} dans le projet {{- parent }}"
      },
      "updateEvent": {
        "tags": "A modifié les tags de l'événement {{- name }} dans le projet {{- parent }}",
        "addParticipants": "A ajouté des participants à l'événement {{- name }} dans le projet {{- parent }}",
        "removeParticipants": "A retiré des participants à l'événement {{- name }} dans le projet {{- parent }}",
        "updateParticipants": "A modifié les participants de l'événement {{- name }} dans le projet {{- parent }}",
        "startDate": "A modifié la date de début de l'événement {{- name }} dans le projet {{- parent }}",
        "endDate": "A modifié la date de fin de l'événement {{- name }} dans le projet {{- parent }}",
        "name": "A modifié le nom de l'événement {{- name }} dans le projet {{- parent }}",
        "description": "A modifié la description de l'événement {{- name }} dans le projet {{- parent }}",
        "move": "A déplacé l'événement {{- name }} dans le projet {{- parent }}"
      },
      "updateTask": {
        "name": "A modifié le titre de la tâche {{- name }} dans le projet {{- parent }}",
        "description": "A modifié la description de la tâche {{- name }} dans le projet {{- parent }}",
        "addAllocation": "A alloué de nouvelles ressources à la tâche {{- name }} dans le projet {{- parent }}",
        "deleteAllocation": "A désalloué des ressources à la tâche {{- name }} dans le projet {{- parent }}",
        "tags": "A modifié les tags de la tâche {{- name }} dans le projet {{- parent }}",
        "startDate": "A modifié la date de commencement de la tâche {{- name }} dans le projet {{- parent }}",
        "endDate": "A modifié la date de fin de la tâche {{- name }} dans le projet {{- parent }}",
        "status": "A modifié le statut de la tâche {{- name }} dans le projet {{- parent }}",
        "move": "A déplacé la tâche {{- name }} dans le projet {{- parent }}"
      },
      "updateActivity": {
        "tags": "A modifié les tags de la liste {{- name }} dans le projet {{- parent }}",
        "name": "A modifié le nom de la liste {{- name }} dans le projet {{- parent }}",
        "description": "A modifié la description de la liste {{- name }} dans le projet {{- parent }}",
        "startDate": "A modifié la date de commencement de la liste {{- name }} dans le projet {{- parent }}",
        "endDate": "A modifié la date de fin de la liste {{- name }} dans le projet {{- parent }}",
        "move": "A déplacé la liste {{- name }} dans le projet {{- parent }}"
      },
      "updateProject": {
        "updateStatus": "A modifié le statut de projet {{- name }} dans le projet {{- parent }}",
        "createStatus": "A créé le statut de projet {{- name }} dans le projet {{- parent }}",
        "deleteStatus": "A supprimé le statut de projet {{- name }} dans le projet {{- parent }}",
        "createProjectResourceGroup": "A créé un nouveau groupe de ressource projet {{- name }} dans le projet {{- parent }}",
        "updateProjectResourceGroup": "A modifié le groupe de ressource projet {{- name }} du projet {{- parent }}",
        "deleteProjectResourceGroup": "A supprimé le groupe de ressource projet {{- name }} du projet {{- parent }}",
        "enableToolsConfig": "A activé des vues pour le projet {{- parent }}",
        "disableToolsConfig": "A désactivé des vues pour le projet {{- parent }}",
        "startDate": "A modifié la date de début du projet {{- parent }}",
        "endDate": "A modifié la date de fin du projet {{- parent }}",
        "label": "A modifié le statut du projet {{- parent }} pour {{- name }}",
        "description": "A modifié la description du projet {{- parent }}",
        "name": "A modifié le nom du projet {{- parent }}",
        "tags": "A modifié les tags du projet {{- parent }}",
        "addProjectResourceMaterial": "A ajouté la ressource matérielle {{- name }} au projet {{- parent }}",
        "addProjectResourceVirtual": "A ajouté la ressource virtuelle {{- name }} au projet {{- parent }}",
        "addProjectResourceHuman": "A ajouté la ressource humaine {{- name }} au projet {{- parent }}",
        "updateProjectResource": "A modifié des ressources au projet {{- parent }}",
        "removeProjectResource": "A supprimé des ressources au projet {{- parent }}",
        "move": "A déplacé le projet {{- parent }} dans la zone {{- name }}",
        "removeProjectResourceMaterial": "A retiré la ressource matérielle {{- name }} au projet {{- parent }}",
        "removeProjectResourceVirtual": "A retiré la ressource virtuelle {{- name }} au projet {{- parent }}",
        "removeProjectResourceHuman": "A retiré la ressource humaine {{- name }} au projet {{- parent }}",
        "activateProjectResourceMaterial": "A activé la ressource matérielle {{- name }} au projet {{- parent }}",
        "disableProjectResourceMaterial": "A désactivé la ressource matérielle {{- name }} au projet {{- parent }}",
        "activateProjectResourceVirtual": "A activé la ressource virtuelle {{- name }} au projet {{- parent }}",
        "disableProjectResourceVirtual": "A désactivé la ressource virtuelle {{- name }} au projet {{- parent }}",
        "activateProjectResourceHuman": "A activé la ressource humaine {{- name }} au projet {{- parent }}",
        "disableProjectResourceHuman": "A désactivé la ressource humaine {{- name }} au projet {{- parent }}"
      },
      "updateProjectTemplate": {
        "updateStatus": "A modifié le statut de projet {{- name }} dans le modèle de projet {{- parent }}",
        "createStatus": "A créé le statut de projet {{- name }} dans le modèle de projet {{- parent }}",
        "deleteStatus": "A supprimé le statut de projet {{- name }} dans le modèle de projet {{- parent }}",
        "createProjectResourceGroup": "A créé un nouveau groupe de ressource projet {{- name }} dans le modèle de projet {{- parent }}",
        "updateProjectResourceGroup": "A modifié le groupe de ressource projet {{- name }} du modèle de projet {{- parent }}",
        "deleteProjectResourceGroup": "A supprimé le groupe de ressource projet {{- name }} du modèle de projet {{- parent }}",
        "enableToolsConfig": "A activé des vues pour le modèle de projet {{- parent }}",
        "disableToolsConfig": "A désactivé des vues pour le modèle de projet {{- parent }}",
        "startDate": "A modifié la date de début du modèle de projet {{- parent }}",
        "endDate": "A modifié la date de fin du modèle de projet {{- parent }}",
        "label": "A modifié le statut du modèle de projet {{- parent }} pour {{- name }}",
        "description": "A modifié la description du modèle de projet {{- parent }}",
        "name": "A modifié le nom du modèle de projet {{- parent }}",
        "tags": "A modifié les tags du modèle de projet {{- parent }}",
        "addProjectResource": "A ajouté des ressources au modèle de projet {{- parent }}",
        "updateProjectResource": "A modifié des ressources au modèle de projet {{- parent }}",
        "removeProjectResource": "A supprimé des ressources au modèle de projet {{- parent }}"
      },
      "updateZone": {
        "name": "A modifié le nom de la zone {{- name }}",
        "description": "A modifié la description de la zone {{- name }}"
      },
      "createProjectStatus": "A créé le statut de projet {{- name }}",
      "deleteProjectStatus": "A supprimé le statut de projet {{- name }}",
      "updateProjectStatus": {
        "label": "A modifié le nom du statut de projet {{- name }}",
        "description": "A modifié la description du statut de projet {{- name }}",
        "color": "A modifié la couleur du statut de projet {{- name }}"
      },
      "createProjectTemplate": "A créé le template de projet {{- name }}",
      "deleteProjectTemplate": "A supprimé le template de projet {{- name }}",
      "createUnavailability": "A créé une nouvelle indisponibilité {{- name }}",
      "deleteUnavailability": "A supprimé l'indisponibilité {{- name }}",
      "updateUnavailability": {
        "reason": "A modifié le type de l'indisponibilité {{- name }}",
        "name": "A modifié le nom de l'indisponibilité {{- name }}",
        "resource": "A modifié la ressource de l'indisponibilité {{- name }}",
        "startDate": "A modifié la date de commencement de l'indisponibilité {{- name }}",
        "endDate": "A modifié la date de fin de l'indisponibilité {{- name }}",
        "nonWorkedHours": "A modifié le nombre d'heures de l'indisponibilité {{- name }}"
      },
      "updatePlanzone": {
        "projectPortfolios": "A modifié les portefeuilles de la Planzone",
        "projectReportTemplate": "A modifié les templates de projet de la Planzone",
        "createProjectReportTemplate": "A créé le modèle de compte rendu {{- name }}",
        "deleteProjectReportTemplate": "A supprimé le modèle de compte rendu {{- name }}",
        "updateProjectReportTemplate": "A modifié le modèle de compte rendu {{- name }}",
        "createProjectPortfolios": "A créé le portefeuille {{- name }}",
        "deleteProjectPortfolios": "A supprimé le portefeuille {{- name }}",
        "updateProjectPortfoliosColor": "A modifié la couleur du portefeuille {{- name }}",
        "updateProjectPortfoliosDescription": "A modifié la description du portefeuille {{- name }}",
        "updateProjectPortfoliosProject": "A modifié les projets lié au portefeuille {{- name }}",
        "updateProjectPortfoliosName": "A modifié le nom du portefeuille {{- name }}",
        "updateProjectPortfolios": "A modifié le portefeuille {{- name }}"
      },
      "createCostProfile": "A créé le profil de coût {{- name }}",
      "deleteCostProfile": "A supprimé le profil de coût {{- name }}",
      "updateCostProfile": {
        "name": "A modifié le nom du profil de coût {{- name }}",
        "description": "A modifié la description du profil de coût {{- name }}",
        "cost": "A modifié l'historique du profil de coût {{- name }}"
      },
      "createGroupPlanzone": "A créé le groupe de ressources {{- name }}",
      "deleteGroupPlanzone": "A supprimé le groupe de ressources {{- name }}",
      "updateGroupPlanzone": {
        "name": "A modifié le nom du groupe de ressources {{- name }}",
        "description": "A modifié la description du groupe de ressources {{- name }}",
        "addResources": "A ajouté des ressources au groupe de ressources {{- name }}",
        "removeResources": "A retiré des ressources au groupe de ressources {{- name }}"
      },
      "createPlanzoneHumanResource": "A créé la nouvelle ressource humaine {{- name }}",
      "createPlanzoneVirtualResource": "A créé la nouvelle ressource virtuelle {{- name }}",
      "createPlanzoneMaterialResource": "A créé la nouvelle ressource matérielle {{- name }}",
      "deletePlanzoneHumanResource": "A supprimé la ressource humaine {{- name }}",
      "deletePlanzoneVirtualResource": "A supprimé la ressource virtuelle {{- name }}",
      "deletePlanzoneMaterialResource": "A supprimé la ressource matérielle {{- name }}",
      "updatePlanzoneHumanResource": {
        "name": "A modifié le nom de la ressource humaine {{- name }}",
        "description": "A modifié la description de la ressource humaine {{- name }}",
        "profession": "A modifié la profession de la ressource humaine {{- name }}",
        "tags": "A modifié les tags de la ressource humaine {{- name }}",
        "personalWeeklyCalendar": "A modifié son calendrier personnel",
        "weeklyCalendar": "A modifié le calendrier personnel de la ressource humaine {{- name }}",
        "affiliation": "A modifié les ressources dépendantes de {{- name }}"
      },
      "updatePlanzoneVirtualResource": {
        "name": "A modifié le nom de la ressource virtuelle {{- name }}",
        "description": "A modifié la description de la ressource virtuelle {{- name }}",
        "profession": "A modifié la profession de la ressource virtuelle {{- name }}",
        "tags": "A modifié les tags de la ressource virtuelle {{- name }}",
        "personalWeeklyCalendar": "A modifié son calendrier personnel",
        "weeklyCalendar": "A modifié le calendrier personnel de la ressource virtuelle {{- name }}",
        "affiliation": "A modifié les ressources dépendantes de {{- name }}"
      },
      "updatePlanzoneMaterialResource": {
        "name": "A modifié le nom de la ressource matérielle {{- name }}",
        "description": "A modifié la description de la ressource matérielle {{- name }}",
        "profession": "A modifié la profession de la ressource matérielle {{- name }}",
        "tags": "A modifié les tags de la ressource matérielle {{- name }}",
        "personalWeeklyCalendar": "A modifié son calendrier personnel",
        "weeklyCalendar": "A modifié le calendrier personnel de la ressource matérielle {{- name }}",
        "affiliation": "A modifié les ressources dépendantes de {{- name }}"
      },
      "updateTimeRecord": {
        "personal": "A modifié ses heures allouées",
        "group": "A modifié les heures allouées de la ressource {{- name }}"
      },
      "createStrategicAxes": "A créé le nouvel axe stratégique {{- name }}",
      "deleteStrategicAxes": "A supprimé l'axe stratégique {{- name }}",
      "updateStrategicAxes": {
        "color": "A modifié la couleur de l'axe stratégique {{- name }}",
        "name": "A modifié le nom de l'axe stratégique {{- name }}",
        "code": "A modifié le code de l'axe stratégique {{- name }}",
        "weight": "A modifié le poid de l'axe stratégique {{- name }}"
      },
      "emailSender": {
        "mentionUserInComment": "Un email a été envoyé à {{- name }} après qu'il ai été mentionné dans un commentaire",
        "taskAllocation": "Un email a été envoyé à {{- name }} après qu'il ai eu du temps alloué sur une tâche",
        "projectMember": "Un email a été envoyé à {{- name }} après qu'il ai été ajouté à un projet",
        "userAddedToTask": "Un email a été envoyé à {{- name }} après qu'il ai été ajouté à une tâche",
        "userAddedToProject": "Un email a été envoyé à {{- name }} après qu'il ai été ajouté à un projet",
        "delayedTask": "Un email a été envoyé à {{- name }} pour ses tâches en retard",
        "reportActivity": "Un email a été envoyé à {{- name }} pour son rapport",
        "joinPlanzoneInvitation": "Un email a été envoyé à {{- name }} pour l'inviter à rejoindre une planzone",
        "planzoneNumberOfProjectsReached": "Un email a été envoyé à {{- name }} pour lui indiquer que son nombre de projet dans sa planzone a été atteint",
        "userAddedToPlanzoneNotification": "Un email a été envoyé à {{- name }} pour lui notifier qu'il a été ajouté dans une planzone",
        "userRemovedFromTask": "Un email a été envoyé à {{- name }} après qu'il ai été retiré d'une tâche",
        "userRemovedFromProject": "Un email a été envoyé à {{- name }} après qu'il ai été retiré d'un projet",
        "userAddedToEvent": "Un email a été envoyé à {{- name }} après qu'il ai été ajouté à un évènement",
        "licenseExpired": "Un email a été envoyé à {{- name }} après que sa licence soit expirée",
        "activityReport": "Un email a été envoyé à {{- name }} pour recevoir son rapport d'activité",
        "failure": {
          "mentionUserInComment": "Échec de l'envoi d'email à {{- name }} après qu'il ai été mentionné dans un commentaire",
          "taskAllocation": "Échec de l'envoi d'email à {{- name }} après qu'il ai eu du temps alloué sur une tâche",
          "projectMember": "Échec de l'envoi d'email à {{- name }} après qu'il ai été ajouté à un projet",
          "userAddedToTask": "Échec de l'envoi d'email à {{- name }} après qu'il ai été ajouté à une tâche",
          "userAddedToProject": "Échec de l'envoi d'email à {{- name }} après qu'il ai été ajouté à un projet",
          "delayedTask": "Échec de l'envoi d'email à {{- name }} pour ses tâches en retard",
          "reportActivity": "Échec de l'envoi d'email à {{- name }} pour son rapport",
          "joinPlanzoneInvitation": "Échec de l'envoi d'email à {{- name }} pour l'inviter à rejoindre une planzone",
          "planzoneNumberOfProjectsReached": "Échec de l'envoi d'email à {{- name }} pour lui indiquer que son nombre de projet dans sa planzone a été atteint",
          "userAddedToPlanzoneNotification": "Échec de l'envoi d'email à {{- name }} pour lui notifier qu'il a été ajouté dans une planzone",
          "userRemovedFromTask": "Échec de l'envoi d'email à {{- name }} après qu'il ai été retiré d'une tâche",
          "userRemovedFromProject": "Échec de l'envoi d'email à {{- name }} après qu'il ai été retiré d'un projet",
          "userAddedToEvent": "Échec de l'envoi d'email à {{- name }} après qu'il ai été ajouté à un évènement",
          "licenseExpired": "Échec de l'envoi d'email à {{- name }} après que sa licence soit expirée",
          "activityReport": "Échec de l'envoi d'email à {{- name }} pour recevoir son rapport d'activité"
        }
      },
      "authentication": {
        "usernamePassword": "Vient de se connecter avec son nom d'utilisateur et mot de passe",
        "sso": "Vient de se connecter en utilisant le SSO"
      }
    }
  },
  "documentCreation": {
    "title": "Création d'un document",
    "submit": "Créer",
    "cancel": "Annuler",
    "name": {
      "title": "Nommer le document",
      "placeholder": "Donnez un nom au document"
    },
    "templates": {
      "title": "Template pour le document",
      "emptyDocument": "Vide"
    },
    "folderSelection": {
      "title": "Sélectionnez un dossier"
    }
  },
  "documentEdition": {
    "close": "Fermer"
  },
  "folderUpdate": {
    "title": "Renommer le dossier",
    "placeholder": "Donnez un nouveau nom au dossier",
    "cancel": "Annuler",
    "submit": "Renommer"
  },
  "documentUpdate": {
    "title": "Renommer le fichier",
    "placeholder": "Donnez un nouveau nom au fichier",
    "cancel": "Annuler",
    "submit": "Renommer"
  },
  "taskPopup": {
    "edit": "Modifier",
    "delete": "Supprimer",
    "project": "Fait partie de"
  },
  "eventPopup": {
    "edit": "Modifier",
    "delete": "Supprimer",
    "project": "Fait partie de"
  },
  "assignToTask": {
    "title": "Affecter sur une tâche existante",
    "resourceLabel": "Resource",
    "resourcePlaceholder": "Sélectionner une resource",
    "projectLabel": "Nom du projet",
    "projectPlaceholder": "Sélectionner un projet",
    "taskLabel": "Nom de la tâche",
    "taskPlaceholder": "Sélectionner une tâche",
    "confirm": "Affecter"
  },
  "richTextInput": {
    "link": {
      "title": "Insérer un lien",
      "placeholder": "https://...",
      "remove": "Supprimer le lien"
    },
    "image": {
      "title": "Insérer une image",
      "placeholder": "https://..."
    },
    "youtube": {
      "title": "Insérer une vidéo YouTube",
      "placeholder": "https://www.youtube.com/watch?v=..."
    },
    "confirm": "OK",
    "cancel": "Annuler",
    "toolbar": {
      "bold": "Gras",
      "italic": "Italique",
      "underline": "Souligné",
      "strikethrough": "Barré",
      "alignLeft": "Aligner à gauche",
      "alignCenter": "Centrer",
      "alignRight": "Aligner à droite",
      "bulletList": "Liste à puces",
      "orderedList": "Liste numérotée",
      "taskList": "Cases à cocher",
      "textColor": "Couleur du texte",
      "highlight": "Surlignage",
      "codeBlock": "Bloc de code",
      "blockquote": "Citation",
      "table": "Tableau",
      "image": "Image",
      "link": "Lien",
      "youtube": "Vidéo YouTube",
      "addColumnBefore": "Ajouter colonne avant",
      "addColumnAfter": "Ajouter colonne après",
      "deleteColumn": "Supprimer colonne",
      "addRowBefore": "Ajouter ligne avant",
      "addRowAfter": "Ajouter ligne après",
      "deleteRow": "Supprimer ligne",
      "deleteTable": "Supprimer le tableau"
    }
  },
  "allocationWarnings": {
    "title": "Avertissement",
    "intro": "Attention, la ou les ressources suivantes ne respecte(nt) pas une des règles de planification :",
    "hasDailyAmplitudeWarning": "Dépassement de l'amplitude de travail max ({{threshold}}h) pour la journée du",
    "hasDailyVolumeWarning": "Dépassement du volume de travail max ({{threshold}}h) pour la journée du",
    "hasRestPeriodWarning": "Dépassement de la durée minimale recommandée ({{threshold}}h) entre la date de fin de cette tâche et la suivante le lendemain",
    "hasUnavailabilityWarning": "Vous vous apprêtez à affecter <bold>{{resourceName}}</bold> sur une tâche dont la durée est comprise dans l'une de ses indisponibilités : <bold>{{unavailabilityLabel}}</bold> (<bold>{{unavailabilityDurationHours}}h</bold>)",
    "confirm": "Continuer",
    "cancel": "Annuler"
  },
  "obsPage": {
    "filters": {
      "title": "Filtrer par :",
      "default": "Aucun filtre",
      "resourceStatuses": {
        "label": "Montrer les ressources :",
        "placeholder": "Toutes les ressources",
        "activated": "Activées",
        "deactivated": "Désactivées"
      }
    },
    "title": "Organigramme",
    "createRootUnit": "Unité organisationnelle",
    "addSubUnit": "+ Ajouter",
    "rename": "Renommer",
    "remove": "Supprimer",
    "move": "Déplacer",
    "edit": "Modifier",
    "creation": {
      "title": "Créer une unité organisationnelle",
      "name": "Nom",
      "namePlaceholder": "Nom de l'unité",
      "parent": "Unité parente",
      "root": "Racine (aucun parent)",
      "resources": "Ressources ({{total}})",
      "cancel": "Annuler",
      "submit": "Enregistrer"
    },
    "removal": {
      "title": "Êtes-vous sûr de vouloir supprimer cette unité organisationnelle ?",
      "confirmation": "« {{- name}} » et toutes ses sous-unités seront supprimées définitivement. Les ressources rattachées ne seront pas supprimées mais n'auront plus d'unité. Cette action est irréversible.",
      "cancel": "Annuler",
      "confirm": "Supprimer"
    }
  }
}
